export const strenghts = {
  FSEH1: [
    "Connecting with others",
    "Your personality preferences allow you to easily connect and maintain positive relationships with others.",
    "share-alt",
  ],
  FSEH2: [
    "Networking",
    "Meeting new people and striking up conversations with strangers while making positive first impressions comes naturally to you.",
    "handshake",
  ],
  FSEH3: [
    "Positive Outlook",
    "You tend to maintain a positive outlook on things, even in the face of challenging circumstances.",
    "thumbs-up",
  ],
  FSEH4: [
    "Go getter",
    "You're confident in your approach. Tenacious and optimistic. You can make things happen and try to build meaningful connections with other individuals. ",
    "trophy-alt",
  ],
  FSEH5: [
    "High Energy",
    "You have a tenacity and explosive energy. You get excited by novel or new experiences. You tend to make fast decisions and take risks. When you're up you're up and you take others along with you.",
    "battery-half",
  ],

  FSEL1: [
    "Giving others air time",
    "You're happy not to be in the limelight and provide others with the air time to voice their thoughts, opinions and concerns.",
    "comments",
  ],
  FSEL2: [
    "Self Sufficient",
    "Team work is great, but you're happy to fly solo. You're content in being alone and do not require any interaction with other individuals",
    "male",
  ],
  FSEL3: [
    "Thoughtful",
    "You're likely to think about and analyze your own thoughts and behaviors. You tend to focus on one idea at a time, and genuinely listen to and seek to understand the world around yourself.",
    "chess",
  ],
  FSEL4: [
    "Action orientated",
    "You prefer to get things done rather than discuss and contemplate outcomes in group settings. You're happy to sit at a desk alone, yet feel stimulated and energized.",
    "exclamation",
  ],

  FSAH1: [
    "Harmonious style",
    "You prefer to work with teams that work together harmoniously. Your relationships aren't typically characterised with conflict. In fact you try to avoid conflict and competition. Your goal is to cooperate and make sure that everyone is getting along.",
    "heart",
  ],
  FSAH2: [
    "Supportive",
    "Being supportive means that you are likely to put the goals of the group or others ahead of your own. You tend to avoid conflict situations and try to make sure that everyone is feeling supported and validated. You get satisfaction from being there for others.",
    "life-ring",
  ],
  FSAH3: [
    "Altruistic",
    "You are thoughtful and kind to others. Especially generous towards people in a disadvantaged position and willing to help those who need it.",
    "gift",
  ],
  FSAH4: [
    "Peacemaker",
    "You try to avoid conflict with others or resolve such situations. In group situations you will often act as the mediator or ‘peacemaker’, attempting to appease two arguing or conflicting parties.",
    "hand-peace",
  ],

  FSAL1: [
    "Self Assured",
    "You have a strong sense of self and an assured presence that others can gain confidence from.",
    "chess-queen",
  ],
  FSAL2: [
    "Outspoken and bold",
    "You're like to be the one to speak up first, when most people are afraid to ask the difficult question or raise concerns.",
    "bullhorn",
  ],
  FSAL3: [
    "Convincing",
    "In group situations, you value choosing the right option, rather than keeping everyone happy. You try to be objective, unemotional and typically try to convince others to see things your way in a hope to make the right decision.",
    "sitemap",
  ],

  FSCH1: [
    "Reliable",
    "Others know that they can depend on you. You don't give up and step away from a challenge. When you set your mind to something you're likely to see it through.",
    "check",
  ],
  FSCH2: [
    "Consistent",
    "Your approach to different tasks is consistent. You are committed to achieving an outcome, being meticulous and following a set approach to achieve a quality outcome. ",
    "history",
  ],
  FSCH3: [
    "Goal setter",
    "You're likely to be disciplined in planning ahead, setting goals, working toward them, and persisting amid setbacks. If a super ambitious goal can’t be realised, you will switch to a more attainable one rather than getting discouraged and giving up.",
    "bullseye",
  ],
  FSCH4: [
    "Organised",
    "You have a tendency to organise different aspects of your life. You know where everything, how it all fits, and the process to follow to achieve your goals. You don't waste time and get right to work.",
    "archive",
  ],
  FSCH5: [
    "Rule following",
    "You like rules and norms. They give you comfort and help you achieve your goals. You're likely to be orderly, risk averse, and punctual.",
    "book",
  ],
  FSCH6: [
    "Persistent",
    "You possess a high internal drive and discipline. You tend to persist with tasks that are highly challenging or mundane. You push through no matter what. No matter how large the obstacle, you tend not to give up and always find a way to get things done.",
    "flag",
  ],

  FSCL1: [
    "Adaptability",
    "You are very flexible in your approach. You tend to seize opportunities, change priorities and can deviate from long term plans by easily letting go.",
    "arrows-alt",
  ],
  FSCL2: [
    "Satisfied",
    "You are not too tied to professional or career achievements and may find satisfaction from other sources like family, relationships, hobbies and diversions. Additionally you're not likely to be too affected by setbacks and find it easier to move on.",
    "smile",
  ],
  FSCL3: [
    "Spontaneous",
    "Long term planning, details and sticking to a path isn't your type of thing. You're much more likely to be spontaneous and focused on the current situation rather than what might be around the corner. You can bring that spark, challenge or different point of view that can help a group move forward or arrive at a creative solution.",
    "calendar-times",
  ],
  FSCL4: [
    "Externally motivated",
    "You don't gain satisfaction from your internal drive. You are motivated by the external environment, circumstances, or short term rewards. You may draw inspiration from those around you, or the threat of a looming deadline to work tirelessly to achieve an outcome.",
    "trophy",
  ],
  FSCL5: [
    "Good enough",
    "While perfectionists sometimes waste time worrying about every little detail, sometimes good enough is simply good enough. You are likely to seize the moment and deliver something good enough. Which is a lot better than nothing at all.",
    "star-half",
  ],

  FSNH1: [
    "Channeling negatives",
    "While you may experience worry and anxiety, you sometimes are able to channel these negative feelings into positive behaviors, such as going to the gym or eating healthier.",
    "dumbbell",
  ],
  FSNH2: [
    "Positive stress",
    "Stress and anxiety in life can be a good thing to motivate people, these emotions allow you to be more prepared, anticipate challenges especially when you are able to channel your stressors into productive avenues.",
    "check-square",
  ],
  FSNH3: [
    "Preparer",
    "Your emotional disposition means that at times you strive hard, even in the absence of external reward, for fear of failure, falling behind, or as a way to counteract the hazards that you sense ahead. ",
    "clipboard-list",
  ],
  FSNH4: [
    "Emotionally empathic",
    "You feel a range of emotions and often. Due to your own experiences you may find it easier to see things from someone else's view and empathize with their experience",
    "band-aid",
  ],

  FSNL1: [
    "Emotionally Stable",
    "You tend to react less emotionally and are less easily upset. Even in the face of challenges you remain calm and maintain composure. People may look to you to steady the ship in challenging circumstances.",
    "ship",
  ],
  FSNL2: [
    "Even tempered",
    "You tend to maintain an even emotional disposition. While others may experience emotions of extreme highs and lows, you tend to stay somewhere in the middle. You are not emotionally reactive and tend to respond to most situations in a composed, thoughtful and considered way.",
    "anchor",
  ],
  FSNL3: [
    "Go with the flow",
    "You're are a very relaxed person. You have a go with the flow attitude and take life as it comes. You do not worry or take things too seriously. You also tend to like to associate with people who are relaxed just like yourself.",
    "tint",
  ],

  FSOH1: [
    "Sponge",
    "You are open to new experiences and tend to place yourself in situations where you are more likely to acquire new knowledge and skills, even when compared to people in the same environment.",
    "podcast",
  ],
  FSOH2: [
    "Receptivity",
    "You tend to maintain a curious attitude towards people, situations, ideas and things that are new, different or challenge societal norms. You are not closed off and typically find diverse experiences interesting. ",
    "eye",
  ],
  FSOH3: [
    "Mental flexibility",
    "You are mentally adaptable and may consider typically weird or unacceptable behaviour, situations or activities interesting. You have a high tolerance and appetite for change. You are not threatened by it and are very open to new experiences.",
    "lock-open-alt",
  ],
  FSOH4: [
    "Curious",
    "You find learning thrilling. You are interested in a broad range of topics, concepts and ideas. You tend to gravitate from one idea to another and are not threatened by an intellectual challenge.",
    "graduation-cap",
  ],
  FSOH5: [
    "Out of the box",
    "You are typically a good problem solver. When you are faced by a problem you tend to think about creative ways of facing your challenges. You like to think outside of the box and aren't shy to do things differently.",
    "box",
  ],
  FSOH6: [
    "Aesthetics",
    "You exhibit a strong preference for aesthetics, fantasy, and often experience emotional absorption in artistic and cultural experiences.",
    "magic",
  ],
  FSOH7: [
    "Creative",
    "You have preference for creative outlets, exploring emotions, gut feelings and use empathy to make decisions. You often engage in vivid imagination, fantasy, try new approaches, enjoy fine arts and cultural experiences",
    "paint-brush",
  ],

  FSOL1: [
    "Practical",
    "You are not very artistic or imaginative, you do not see value in unnecessary things. You tend to be dedicated to your work and look at ways to solve problems with a practical approach, ways that work.",
    "wrench",
  ],
  FSOL2: [
    "Traditional",
    "You aren't into exploring or learning about new ideas, understanding taboo topics or people who are too different for their own good. Your first instinct is to go for tried-and-true methods, ´do things properly´, follow a structured routine and not deviate from the 'norm'.",
    "university",
  ],
  FSOL3: [
    "Routine",
    "You like following a set plan. Chopping and changing too much can make you frustrated and takes you further away from your goals.",
    "list-ol",
  ],
  FSOL4: [
    "Black and white",
    "You're often able to make decisions quickly. You see things as black and white, with no grey areas.",
    "map-signs",
  ],
};

export const weaknesses = {
  FDEH1: [
    "High Energy",
    "Your strong preference to interact with others, be talkative, and positive can be burdensome to others who may prefer to work in a quiet focused environment. Be mindful of other people and monitor your energy to make sure that you do not drive away people who do not share outgoing nature.",
    "battery-full",
  ],
  FDEH2: [
    "Boredom",
    "You have a susceptibility to get bored easily. You may need constant activity around you, music playing in the background and others to converse with. Make sure that you keep yourself stimulated when working on detail focused tasks, take regular breaks and switch between short term payoffs and long term payoffs to keep your interest up.",
    "hourglass-start",
  ],
  FDEH3: [
    "Alone time",
    "Not being around people. Your biggest enemy. It's not that you can't work alone, you'd just prefer to be in a group and it can really take toll on your productivity. Where possible try to find similar minded people and structure activities as group brainstorming sessions, group planning days or peer feedback round tables.",
    "universal-access",
  ],
  FDEH4: [
    "Excitement seeker",
    "You are likely to be interested in novel experiences. This also may include risky experiences. Sometimes this means that the regular structured life that many others lead does not appeal to you. Make sure that when you do engage in new experiences or step outside of the norm, that you reflect and take on any new learnings. ",
    "luchador",
  ],
  FDEH5: [
    "Balance talk",
    "Although forming relationships and holding conversation may be a strength, it’s important that you find a balance between talking and listening. Validate others and make sure they feel heard. This strategy will help you become a resource for others, as well as maintain solid meaningful relationships that extend beyond the superficial.",
    "balance-scale",
  ],
  FDEH6: [
    "Impulsive",
    "You have a restless desire to explore new boundaries, work well in rapidly changing environments, ready to move on at short notice, whether this is physically or to a new relationship, job or career. Sometimes you can commit to new adventures without thinking through all of the consequences. Before making a decision take some time to consider all the pros and cons. Don't just say yes to everything.",
    "bomb",
  ],

  FDEL1: [
    "Connecting with others",
    "You personality preferences mean that you may find it hard to form relationships with others, especially if they are not known to you. Where necessary, step outside of your comfort zone and try to lead the conversations. Use small talks. Find common ground and you may be surprised that others respond in a positive way.",
    "share-alt",
  ],
  FDEL2: [
    "Distracted by noise",
    "You have a preference for solitude and silence. You're likely to suffer distractions from people, noise, or stimulants of any kind. These can be really disruptive to your ability to focus. You're likely to feel less comfortable, less efficient, and less helpful in a noisy or group environment.",
    "headphones",
  ],
  FDEL3: [
    "Silent",
    "You have probably thought things through thoroughly, have great ideas and thoughts that could often help others. Unfortunately, you not vocal or volunteer information in group settings. As a result your ideas and opinions may often get overlooked in favor of the more confident group contributors. ",
    "microphone-slash",
  ],
  FDEL4: [
    "Energy levels",
    "You may find that you are often feeling tired, or burnt out by meetings and interaction with other people. Sometimes others can read this as you being uninterested, closed off or unapproachable. Set aside time to engage with others, but make sure that you let them know your preferred methods of communication.",
    "battery-half",
  ],

  FDAH1: [
    "Making hard decisions",
    "Your preference for accomodating others, can lead to internal conflict when difficult decisions need to be made. You may find it challenging to make decisions that have drawbacks or impact negatively on other people.",
    "question",
  ],
  FDAH2: [
    "Avoiding conflict",
    "Your tendency to avoid conflict when dealing with other people may be counterproductive. At times conflict is necessary to progress or resolve certain challenges. You may experience personal growth from engaging in more opinionated exchanges with others and respectfully challenging their point of view when you disagree.",
    "boxing-glove",
  ],
  FDAH3: [
    "Putting others ahead of self",
    "Being group and people orientated often means that you put the good of the group or others ahead of yourself. Look for opportunities to find win win situations for everybody, even yourself.",
    "users",
  ],
  FDAH4: [
    "Asking and telling",
    "You may overwork yourself due to an inability to delegate appropriately or ask others for help when you are stuck. You may also have difficulty delivering bad news, giving criticism, and standing up for yourself in the face of unfair criticism.",
    "comment-alt",
  ],
  FDAH5: [
    "Separate identity",
    "Sometimes you may find it very difficult to separate your identity from the group. You get a lot of satisfaction from belonging. This means that at times you will go with the group even though you may not really agree with it. Challenging norms and group decisions is healthy and often leads to better outcomes. ",
    "id-card",
  ],

  FDAL1: [
    "Confrontational",
    "At times it may appear like you enjoy being argumentative. Although holding a position that is not in agreeance with others is fine, you may need to be more flexible in relinquishing control. Allowing others to drive the agenda and lead, even when you are not in 100% agreement can be beneficial to team harmony.",
    "boxing-glove",
  ],
  FDAL2: [
    "Inconsiderate of others perspective",
    "Being empathic can be challenging at the best of times. Try and be considerate of others' emotional well being and the position they are coming from. Take their thoughts, feelings and actions into consideration and think about how your responses may impact others before expressing them.",
    "eye-slash",
  ],
  FDAL3: [
    "Persistent or inflexible approach",
    "Trusting in others is important. Allowing or incorporating other perspectives and thoughts can strengthen our own approach. Work on being more emotionally supportive and inclusive of others.",
    "shield-alt",
  ],
  FDAL4: [
    "Agree to disagree",
    "You have a preference to work according to your own tune. Your relationships can suffer from conflict due to your preference to test yourself against others. Your goal should be to cooperate and try to accommodate others in order to create better working relationships.",
    "exchange-alt",
  ],
  FDAL5: [
    "Restrain judgement",
    "Restrain initial thoughts or judgements of others. Giving more time to others before writing them off, may help you form a more accurate perception of others than your natural instincts may initially indicate.",
    "crosshairs",
  ],
  FDAL6: [
    "Self Focused",
    "You tend to be more focused on your own personal needs, even when these conflict with the interests of others. As a result your peers may view your behaviour as somewhat selfish. Try to take the needs of others into account when interacting, compromising or trying to achieve a shared goal with others.",
    "street-view",
  ],
  FDAL7: [
    "Suspicious",
    "Your low score on agreeableness can manifest itself in suspicion and distrust of others. Because you are unsure of the motives of others you may be more argumentative, and be less willing to engage in conversations with, or socialise with, unfamiliar people. Trust that most people are not naturally out to cause you distress.",
    "low-vision",
  ],

  FDCH1: [
    "Decision making",
    "You may find that sometimes you get bogged down by the details. This means that making any type of decision can take longer and have a cost attached to it if there is a critical deadline.",
    "question",
  ],
  FDCH2: [
    "Multi focus",
    "Your level of conscientiousness is great in achieving tasks, however you may find it challenging to split your attention amongst multiple tasks. As a consequence it may take you longer to shift focus, ramp up and down between tasks.",
    "sliders-h",
  ],
  FDCH3: [
    "Rule Follower",
    "While you have a strong appreciation for rules, following the rulebook at all times can be counterproductive, interfere, block or annoy creative and innovative oriented people. Most importantly, strictly adhering to rules can stifle innovation. Try to appreciate that sometimes rules do not apply cleanly and experiment when possible.",
    "book",
  ],
  FDCH4: [
    "Risk Averse",
    "You may have trouble dealing with ambiguity and making decisions that have risk attached. Taking a leap of faith without all the facts, information or potential outcomes can be anxiety provoking. This mindset, while safe, can prevent you from trying new things and experimenting. ",
    "bolt",
  ],
  FDCH5: [
    "Fault attribution",
    "Being detail minded, driven to achieve quality outcomes, and follow rules means that when things do break down you may step up and take the blame. It may not be directly your fault, but because of your conscientiousness you may feel like the negative outcome is directly attributed to your efforts. Be realistic about the bad outcome. Analyse it! You're good at this and don't automatically attribute the failure to yourself.",
    "times",
  ],
  FDCH6: [
    "Perfectionist",
    "Sometimes you may spend too much time worrying about every little detail that you miss the forest through the trees. A good something is better than a perfect nothing. You may fail seize the moment and deliver something 'good enough' or something all together.",
    "tree",
  ],

  FDCL1: [
    "Weak Planning",
    "You have a preference for living in the moment. Planning and thinking about the long term is something that you find challenging and mundane. As far as you are concerned, considering all of the different future scenarios could be a waste of time or even pointless. You are very changeable and reactive to your environment, and as a result you may find it hard to predict, plan and strategize for the long term.",
    "calendar-times",
  ],
  FDCL2: [
    "Lack Persistence",
    "You lack the internal drive and discipline to persist with tasks that may end up being too challenging, mundane or not as interesting as a new distraction. Persist, you may feel incredible self relief or a sense of accomplishment by seeing things through.",
    "tasks",
  ],
  FDCL3: [
    "Impulsive",
    "You may find it difficult to show self-discipline, motivate yourself to complete mundane tasks, and act dutifully. You have a preference to ignore rules, try creative solutions even in the face of failure, and make decisions without considering all of the facts.",
    "bomb",
  ],
  FDCL4: [
    "Reliability",
    "Others may find it difficult to depend on you. You tend to give up and step away from a challenge before even committing fully. You may have a low threshold for long term projects where there isn't a short term payoff. Completing tasks can be challenging and you may find yourself moving on to new projects rather than finishing old ones.",
    "check",
  ],
  FDCL5: [
    "Rule Avoidant",
    "You don't have a strong appreciation for rules. For you following a rulebook can be challenging and tedious. While you may have a strong preference to be more adaptable and carefree in your approach, adhering to rules can provide consistency and reliability to others around you. They may feel like they are able to depend on you. Try and balance your need for novelty with being reliable and consistent for others.",
    "book",
  ],
  FDCL6: [
    "Procrastinator",
    "You can procrastinate, and you sometimes tend to put off your responsibilities until the last minute. If something fun comes up, it doesn't bother you to put your responsibilities off until the next day.",
    "cloud",
  ],

  FDNH1: [
    "Emotionally Reactive",
    "Your emotional responses to situations that would not affect most people tend to be over the top and volatile.Take a moment, remove yourself from the situation and assess what happened calmly.",
    "thermometer-three-quarters",
  ],
  FDNH2: [
    "Moody",
    "When compared to others you may experience more negative emotions and end up in a bad mood more frequently. ",
    "thumbs-down",
  ],
  FDNH3: [
    "Control",
    "You may experience difficulty in thinking clearly, controlling your feelings and being able to cope with stress. In situations where things feel like they are getting too much, take a step back and try to steady yourself. More importantly, find ways to channel your stressors into more productive avenues such as eating healthy, exercising, preparing adequately and anticipating problems that you can deal with before they happen.",
    "gamepad",
  ],
  FDNH4: [
    "Self Conscious",
    "At times you may feel vulnerable and open to the judgement of others. The anxiety of being put in situations where you have limited control or things can go wrong may prove too much or get on top of you. Ask others for feedback, invite them to provide you with ways to improve, reflect on those situations that stress you out and grow from them. Use them as a point of strength.",
    "id-card-alt",
  ],
  FDNH5: [
    "Worrier",
    "You may experience feelings of anxiety or worry about future situations. There are reasons to worry, and reasons not to worry. If your reasons are realistically tied to what's happening in your life, don't add guilt over feeling negative to your existing feelings of sadness or anxiety. Make sure to use this anxiety as a way of preparing, staying ahead, or anticipating any challenges that may arise.",
    "calendar-alt",
  ],

  FDNL1: [
    "Not bothered",
    "Your lack of emotional reactivity, calm presence and even tempered nature may mean that sometimes people can misinterpret this as a lack of not caring. Make sure that you communicate your concerns to others and help them understand why you may not be panicking when they may be feeling overwhelmed.",
    "thermometer-quarter",
  ],
  FDNL2: [
    "Lack anticipation",
    "Stress and anxiety in life can be a good thing to motivate people, these emotions allow you to be more prepared and anticipate challenges. Your relaxed nature may mean that sometimes you don't anticipate risks or stress about certain negative scenarios.",
    "binoculars",
  ],
  FDNL3: [
    "Emotionally unempathetic",
    "Other people are likely to stress and feel more negative emotions than you. You may find it hard to understand or place yourself in their shoes. Make sure when someone is feeling stressed or down in situations where you may not be, that you take the time to try to understand their perspective and empathize with them. Help them by providing ways to deal with their negative mood or emotional volatility.",
    "anchor",
  ],

  FDOH1: [
    "Intellectual superiority",
    "You're a quick learner. Even quicker at analyzing problems, patterns or fuzzy rule sets. Because others can sometimes take longer than you to work things out for themselves they may see your eagerness to move on as pompous, short and judgemental of their capability. You need to be mindful that others may take more time than you to arrive at a conclusion.",
    "chess",
  ],
  FDOH2: [
    "Novelty seeking",
    "You hate being in a routine. You're constantly looking for new things to do, new challenges to overcome. If things become too repetitive you can feel like you're in a slump and often look to make a change. This flexibility could be seen as a lack of commitment or passion, being too changeable and being bored.",
    "rocket",
  ],
  FDOH3: [
    "Idea generator",
    "You have a flair for being creative. Thinking about new ways to do things. Sometimes this can be too much for others. You can be unfocused or generate too many ideas that end up leading you up the garden path. This can at times be frustrating to others. When working with more concrete or traditional people try not to overwhelm them. Offer practical solutions and stick to a plan.",
    "lightbulb",
  ],
  FDOH4: [
    "Rebellious",
    "You tend to have a rebellious streak. You don't value conformity, can sometimes break rules because they make no sense to you and question well established frameworks. While these are positive characteristics if you are trying to solve problems creatively, it can be counterproductive if you are always trying to reinvent the wheel.",
    "user-secret",
  ],
  FDOH5: [
    "Explorer",
    "You always remain mentally agile when approaching problems, handing whatever life throws at you. However, this trait also means that you typically take more time to make decisions than others do. Try to narrow down your ideas to a few critical approaches that may have worked for you in the past.",
    "compass",
  ],

  FDOL1: [
    "Routine",
    "You like following a set plan. Chopping and changing too much can make you frustrated and takes you further away from your goals. You need to be in an environment that's predictable.",
    "list-ol",
  ],
  FDOL2: [
    "Black and white",
    "You often see things as black and white. You do not see shades of grey. As a result you can quickly jump to conclusions and do not like to entertain that there may be a fuzzy middle area. This can sometimes limit discussions or your ability to interact with people who do not follow the norm,  enjoy to explore or discuss abstract ideas.",
    "map-signs",
  ],
  FDOL3: [
    "Traditional",
    "You aren't into trying untested methods. Your first instinct is to go for tried-and-true methods, follow a structured routine and not deviate too much from the plan. This can be a problem when considering new problems, situations, people or challenges.",
    "university",
  ],
};

export const personas = {
  personablePersona: {
    id: "p01",
    title: "Personable Persona",
    description:
      "Personable Personas enjoy interacting with other people. Personable individuals frequently experience and express positive emotions and are therefore typically well-liked by others. They derive satisfaction from helping, and are well-suited for careers in the helping professions (counseling, teaching, nursing, human services). They are described by others as cheerful, confident, sociable, vigorous, enthusiastic, and friendly.",
    tags: ["enthusiastic", "happy", "friendly", "cheerful"],
    image: "p01.svg",
    strenghts: ["FSEH1", "FSEH2", "FSEH3"],
    weaknesses: ["FDAH1", "FDAH2", "FDAH3"],
  },
  domineeringPersona: {
    id: "p02",
    title: "Power Persona",
    description:
      "Power Personas thrive when they are in charge of others. But sometimes, they can exert their power without thinking about other people's feelings. When this happens, others can see them as critical, bossy, and stubborn.",
    tags: ["bullheaded", "abrupt", "strong", "combative", "rough"],
    image: "p02.svg",
    strenghts: ["FSEH1", "FSEH2", "FSAL1"],
    weaknesses: ["FDAL1", "FDAL2", "FDAL3"],
  },
  humblePersona: {
    id: "p03",
    title: "Humble Persona",
    description:
      "Humble Personas are warm, gentle, and peace-loving. They tend to get along, thrive on social acceptance and go with the majority. People describe them as calm, easy-going, and pleasant.",
    tags: ["soft-hearted", "agreeable", "obliging", "humble", "lenient"],
    image: "p03.svg",
    strenghts: ["FSEL1", "FSAH1", "FSAH2"],
    weaknesses: ["FDAH1", "FDEL1", "FDAH3"],
  },
  distantPersona: {
    id: "p04",
    title: "Solo Persona",
    description:
      "Solo Personas enjoy their alone time, often preferring solitude to company. As they tend to keep to themselves, others may see them as 'loners', or as shy, introverted worriers. Sometimes, this standoffish nature can make them appear rude to others when misunderstood.",
    tags: ["cynical", "wary of others", "solitary", "withdrawn", "impersonal"],
    image: "p04.svg",
    strenghts: ["FSEL3", "FSEL2", "FSEL1"],
    weaknesses: ["FDAL4", "FDAL5", "FDEL1"],
  },
  enterprisingPersona: {
    id: "p05",
    title: "Enterprising Persona",
    description:
      "Enterprising Personas are ambitious, competitive and driven to achieve success. They are purposeful about their life. Because of these motivators, they'll most likely desire being in positions of authority.",
    tags: ["ambitious", "alert", "firm", "purposeful", "competitive"],
    image: "p05.svg",
    strenghts: ["FSEH4", "FSCH1", "FSCH3"],
    weaknesses: ["FDEH1", "FDCH1", "FDCH4"],
  },
  impulsivePersona: {
    id: "p06",
    title: "Impulsive Persona",
    description:
      "Impulsive Personas have bold personalities that enjoy being centre of attention. Look at me! They thrive in social situations. They're unique individuals who aren't afraid to take risks. Others describe them as chatty, unpredictable, and blunt - you'll always know where you stand.",
    tags: ["unruly", "boisterous", "careless", "energetic"],
    image: "p06.svg",
    strenghts: ["FSEH4", "FSCH1", "FSCH3"],
    weaknesses: ["FDCL4", "FDCL3", "FDEH4"],
  },
  industriousPersona: {
    id: "p07",
    title: "Hardworking Persona",
    description:
      "Hardworking Personas are orderly and self-disciplined. They persevere and work hard to achieve their goals. They work very well without close supervision and prefer to just get on and work on their own.  Hardworking Personas have great respect for rules and social customs. Others describe them as considerate, cooperative, and accountable.",
    tags: ["cautious", "confident", "punctual", "formal", "efficient"],
    image: "p07.svg",
    strenghts: ["FSCH3", "FSCH4", "FSEL4"],
    weaknesses: ["FDEL4", "FDCH1", "FDEL1"],
  },
  apatheticPersona: {
    id: "p08",
    title: "Laid-back Persona",
    description:
      "Laid-Back Personas are relaxed about life, not fussed and happily go wherever life takes them. Others could see this as passive or inconsistent.",
    tags: ["indecisive", "aimless", "low energy", "not fussed"],
    image: "p08.svg",
    strenghts: ["FSCL2", "FSEL1", "FSCL4"],
    weaknesses: ["FDCL4", "FDEL4", "FDEL2"],
  },
  selfconfidentPersona: {
    id: "p09",
    title: "Socially Confident Persona",
    description:
      "Socially Confident Personas are extraverts with a lot of energy and self-confidence. This makes them well-suited for leadership-type roles. Others may describe them as sociable, self-assured, active, and ambitious.",
    tags: ["carefree", "self confident", "comfortable"],
    image: "p09.svg",
    strenghts: ["FSEH4", "FSEH3", "FSNL1"],
    weaknesses: ["FDEH5", "FDNL2", "FDEH3"],
  },
  moodymanicPersona: {
    id: "p10",
    title: "Up Down Persona",
    description:
      "Up Down Personas are emotional extraverts who wear their feelings on their sleeve. They may have some difficulty keeping their emotons in check, so can often bounce quickly from one mood to another. Others may describe them as unpredictable, excitable, and lively.",
    tags: ["excitable", "wordy", "emotional", "explosive", "extravagant"],
    image: "p10.svg",
    strenghts: ["FSNH3", "FSEH5", "FSEH4"],
    weaknesses: ["FDEH4", "FDNH3", "FDNH1"],
  },
  satisfiedPersona: {
    id: "p11",
    title: "Satisfied Persona",
    description:
      "Satisfied Personas feel content with things just as they are. They don't see a point in fighting to be at the top of the heap. Stability and security are most important to Satisfied Personas. So, they'll likely be happy in a respectable job earning enough money to live a good and 'regular' life. Others may describe them as responsible, balanced, and humble.",
    tags: ["unassuming", "content", "placid", "tranquil"],
    image: "p11.svg",
    strenghts: ["FSEL1", "FSNL2", "FSEL2"],
    weaknesses: ["FDEL3", "FDEL4", "FDNL1"],
  },
  discouragedPersona: {
    id: "p12",
    title: "Disheartened Persona",
    description:
      "Disheartened Personas may currently be feeling unhappy with their present life situation. They may even be feeling powerless to change things for the better. As such, others may see them as shy or withdrawn, anxious, and energetically flat.",
    tags: ["guarded", "fretful", "low confidence", "pessimistic", "deterred"],
    image: "p12.svg",
    strenghts: ["FSNH2", "FSEL3", "FSEL2"],
    weaknesses: ["FDNH1", "FDNH3", "FDEL4"],
  },
  debonairPersona: {
    id: "p13",
    title: "Charming Persona",
    description:
      "Charming Personas are witty and likeable - intelligent extraverts. They can be super dramatic and comical; fun to be around. So, people are naturally attracted to them and describe them as confident, eloquent, and progressive. But if a Charming Persona dislikes someone, they can quickly cut that person out! Ouch. So, these personas can also be seen as critical and blunt when their main tendencies are combined with the wrong levels of agreeableness and neuroticism.",
    tags: ["worldly", "theatrical", "eloquent", "inquisitive", "intense"],
    image: "p13.svg",
    strenghts: ["FSEH1", "FSEH5", "FSOH4"],
    weaknesses: ["FDOH1", "FDEH5", "FDOH2"],
  },
  indescretePersona: {
    id: "p14",
    title: "Self-Assured Persona",
    description:
      "Self-Assured Personas have big, bold, cheeky personalities and love to talk. They can appear very confident, sometimes even when they may not know a lot about the topic or area. Self-Assured Personas can talk over people and miss their opinions, so somtimes may be seen as self-centred and lacking self-awareness.",
    tags: ["verbose", "cunning", "self absorbed", "confident"],
    image: "p14.svg",
    strenghts: ["FSEH4", "FSOL1", "FSEH1"],
    weaknesses: ["FDOL3", "FDOL2", "FDEH5"],
  },
  bookwormPersona: {
    id: "p15",
    title: "Bookworm Persona",
    description:
      "Bookworm Personas are very smart and thoughtful people. They're hungry to learn more about their world and who they are as individuals. While they like to keep to themselves and avoid large social gatherings, their intelligence is well known and respected. People may describe them as well-read, calm natured and curious.",
    tags: [
      "introspective",
      "meditative",
      "contemplating",
      "self-examining",
      "inner-directed",
    ],
    image: "p15.svg",
    strenghts: ["FSEL3", "FSOH1", "FSOH4"],
    weaknesses: ["FDOH5", "FDEL3", "FDEL4"],
  },
  lethargicPersona: {
    id: "p16",
    title: "Low-Key Persona",
    description:
      "Low-Key Personas are happy to go with the flow through life. They like to stick with what feels familiar, keeping the same friends, habits and routines. They prefer to take direction rather than to give it. Others may see them as easy-going, restrained and mellow.",
    tags: ["predictable", "practical", "unadventurous"],
    image: "p16.svg",
    strenghts: ["FSOL1", "FSOL4", "FSEL4"],
    weaknesses: ["FDEL4", "FDEL2", "FDOL3"],
  },
  compromisingPersona: {
    id: "p17",
    title: "Harmonious Persona",
    description:
      "Harmonious Personas always aim to get along with others because they value 'good' relationships. This means they're likely to be first to compromise to avoid any conflict or showdowns. Others describe them as trustworthy, co-operative, down-to-earth, persevering and understanding.",
    tags: ["dependable", "responsible", "reliable", "mannerly", "considerate"],
    image: "p17.svg",
    strenghts: ["FSAH1", "FSCH4", "FSCH1"],
    weaknesses: ["FDAH1", "FDAH4", "FDCH4"],
  },
  otherdirectedPersona: {
    id: "p18",
    title: "Guided Persona",
    description:
      "Guided Personas are happy just to hang out with their friends and enjoy a breezy life. They are easy-going and prefer being guided by other people, as they aren't opinionated. Others describe them as relaxed, humble, and agreeable.",
    tags: ["unpretentious", "considerate", "modest"],
    image: "p18.svg",
    strenghts: ["FSAH2", "FSAH3", "FSCL2"],
    weaknesses: ["FDCL2", "FDAH3", "FDAH2"],
  },
  moralisticPersona: {
    id: "p19",
    title: "Principled Persona",
    description:
      "Principled Personas are rule-oriented achievers who aim to get the job 'done right'. Sometimes, this means they ignore the feelings of others. That's because principles are more important to them than people. Principled Personas work hard to achieve goals and often show strong initiative, which helps propel them into leadership roles. They believe in working with and through the system to get ahead. They're unlikely to take big risks or be seen mucking around. Others describe them as serious, quiet, and firm.",
    tags: ["stern", "rule following", "uncompromising", "detail focused"],
    image: "p19.svg",
    strenghts: ["FSCH4", "FSAL3", "FSCH5"],
    weaknesses: ["FDAL3", "FDCH3", "FDAL4"],
  },
  selfcenteredPersona: {
    id: "p20",
    title: "Self-Seeking Persona",
    description:
      "Self-Seeking Personas tend to act in self-interest. That is, they will aim to meet their needs first before meeting the needs of others. Because of this, others may see them as individualistic, stubborn, unreliable, or cheeky.",
    tags: ["rash", "strong willed", "unreliable", "individualistic"],
    image: "p20.svg",
    strenghts: ["FSCL5", "FSCL1", "FSAL2"],
    weaknesses: ["FDAL6", "FDAL1", "FDCL3"],
  },
  pleasantPersona: {
    id: "p21",
    title: "Pleasant Persona",
    description:
      "Pleasant Personas are full of positive emotions and free from negative emotions. They're widely liked because of their relaxed, down-to-earth nature. Others describe them as cheerful, warm, tolerant, calm, cooperative and kind.",
    tags: ["patient", "relaxed", "undemanding", "down-to-earth"],
    image: "p21.svg",
    strenghts: ["FSAH3", "FSAH2", "FSNL3"],
    weaknesses: ["FDNL2", "FDAH2", "FDAH4"],
  },
  emotionalPersona: {
    id: "p22",
    title: "Emotional Persona",
    description:
      "Emotional Personas are in touch with both positive and negative feelings. Whether male or female, they have personality traits often seen as feminine in nature. For example, they are caring, affectionate, sensitive, and passionate.",
    tags: ["agreeable", "trusting", "affectionate", "sensitive", "caring"],
    image: "p22.svg",
    strenghts: ["FSAH2", "FSNH3", "FSNH4"],
    weaknesses: ["FDNH1", "FDNH4", "FDAH1"],
  },
  unemotionalPersona: {
    id: "p23",
    title: "Unemotional Persona",
    description:
      "Unemotional Personas see themselves as strong, stable, and unaffected by emotions. Whether male or female, they have personality traits stereotypically seen as masculine in nature. An Unemotional Persona may think that showing emotions is a sign of weakness. As such, people can see them as strong but emotoinally distant.",
    tags: ["easy going", "cool", "unaffectionate", "detached"],
    image: "p23.svg",
    strenghts: ["FSAL3", "FSNL1", "FSAL2"],
    weaknesses: ["FDNL3", "FDAL2", "FDAL4"],
  },
  moodyPersona: {
    id: "p24",
    title: "Moody Persona",
    description:
      "Moody Personas report feeling many negative emotions and few positive ones. They may be worriers who are easily irritated by their cicrumstance or other people. Their moods can fluctuate from one to the other quite quickly. Others can see them as passionate, impatient, distant, and stubborn.",
    tags: ["temperamental", "irritable", "impatient", "strong willed"],
    image: "p24.svg",
    strenghts: ["FSAL2", "FSNH2", "FSNH3"],
    weaknesses: ["FDNH3", "FDNH2", "FDAL6"],
  },
  tolerantPersona: {
    id: "p25",
    title: "Open Persona",
    description:
      "Open Personas are easy-going and accepting of differences in other people. As they care about the feelings of others, they'll consider all opinions when making decisions. They get on well with almost everyone they meet, so most people see them as friendly, calm, and thoughtful.",
    tags: ["tolerant", "diplomatic", "deep", "friendly", "tactful"],
    image: "p25.svg",
    strenghts: ["FSAH3", "FSAH4", "FSOH2"],
    weaknesses: ["FDOH5", "FDAH3", "FDAH2"],
  },
  gulliblePersona: {
    id: "p26",
    title: "Trusting Persona",
    description:
      "Trusting Personas happily follow the crowd because they trust the crowd knows the right way. They're easy-going with most things, so tend to enjoy a more simple life. Others may see them as down-to-earth, humble, and somtimes gullible.",
    tags: ["straightforward", "dependent", "unpretentious", "humble"],
    image: "p26.svg",
    strenghts: ["FSAH2", "FSAH3", "FSOL3"],
    weaknesses: ["FDOL3", "FDAH5", "FDAH3"],
  },
  individualisticPersona: {
    id: "p27",
    title: "Unique Persona",
    description:
      "Unique Personas consider themselves smarter than the average person. They have a quirky outlook and approach to life. In the extreme they can also be eccentric. In most cases, they're seen for their big imagination, intelligence, and enthusiasm.",
    tags: ["sharp", "eccentric", "individualistic"],
    image: "p27.svg",
    strenghts: ["FSAL1", "FSOH7", "FSOH5"],
    weaknesses: ["FDOH1", "FDOH3", "FDAL5"],
  },
  narrowmindedPersona: {
    id: "p28",
    title: "Closed Persona",
    description:
      "Closed Personas are very independent and will look after themselves without needing help. They feel more comfortable being around others like them, so they may not always make an effort to meet people who are different. When someone annoys them they'll be quick to speak up and say so! While some like this open book approach, others can find this blunt honesty hard to deal with. As such, people may describe Closed Personas as direct, stony, or prickly.",
    tags: ["bold", "individualistic", "narrow focus", "straightforward"],
    image: "p28.svg",
    strenghts: ["FSOL2", "FSAL2"],
    weaknesses: ["FDAL5", "FDAL4", "FDOL2"],
  },
  persistentPersona: {
    id: "p29",
    title: "Persistent Persona",
    description:
      "Persistent Personas are hard-working, steady and committed. They work well  when they have rules and systems to follow (which they'll always stick to!). Others see them as trustworthy, predictable, and level-headed.",
    tags: ["committed", "objective", "steady", "logical", "rule following"],
    image: "p29.svg",
    strenghts: ["FSCH1", "FSCH6", "FSNL1"],
    weaknesses: ["FDNL1", "FDCH1", "FDCH5"],
  },
  fussyPersona: {
    id: "p30",
    title: "Fussy Persona",
    description:
      "Fussy Personas are perfectionists who crave structure and order, but never seem to get it. Because they're always chasing perfection, they can get in their own way of success. Others can see them as choosy, cautious, and tense.",
    tags: ["particular", "high-strung", "detail focused"],
    image: "p30.svg",
    strenghts: ["FSNH3", "FSNH2", "FSCH4"],
    weaknesses: ["FDCH6", "FDCH3", "FDNH5"],
  },
  carefreePersona: {
    id: "p31",
    title: "Carefree Persona",
    description:
      "Carefree Personas are cool, simple, happy-go-lucky types. They don't care about rules and routines, but they aren't against them either. They just go with the flow as their heart pleases. Others describe them as free, flexible, and casual.",
    tags: ["informal", "low-key", "composed"],
    image: "p31.svg",
    strenghts: ["FSCL1", "FSCL2", "FSNL3"],
    weaknesses: ["FDNL1", "FDCL2", "FDCL1"],
  },
  scatteredPersona: {
    id: "p32",
    title: "Scattered Persona",
    description:
      "Scattered Personas may feel a bit uncertain about what they want in life. This can affect how they think and how they are with other people. Internally, their needs are often changing, and they become forgetful. When in groups, Scattered Personas can be curious, showing a lot of interest in others. But they can also be impulsive and act without warning or thinking things through (which some will find frustrating!). Others describe them as unpredictable and hard to understand.",
    tags: ["tense", "self-indulgent", "forgetful", "impulsive"],
    image: "p32.svg",
    strenghts: ["FSCL3", "FSCL4", "FSNH3"],
    weaknesses: ["FDCL3", "FDNH1", "FDCL4"],
  },
  culturedPersona: {
    id: "p33",
    title: "Cultured Persona",
    description:
      "Cultured Personas are big, creative thinkers with a super analytical approach. They are reserved and persevering. Some may have a classy or refined nature, for example, formal manners or stylish clothing. Wise and intuitive, they're able to solve big problems quickly. Cultured Personas have an eye for details, so they suit jobs needing concentration. Other people can see them as rule-abiding, dependable, curious, leader-like, and reliable.",
    tags: ["analytical", "perceptive", "informative", "articulate"],
    image: "p33.svg",
    strenghts: ["FSOH6", "FSOH7", "FSCH4"],
    weaknesses: ["FDCH6", "FDOH1", "FDCH1"],
  },
  conventionalPersona: {
    id: "p34",
    title: "Process Persona",
    description:
      "Process Personas prefer to 'go by the book' and follow traditions. Rarely will they improvise or try something different there is a proven approach to follow. They are responsible and can be relied on to follow directions and get the job done. Others see them as agreeable, uncomplicated, and down-to-earth.",
    tags: ["conventional", "traditional", "reliable", "risk averse"],
    image: "p34.svg",
    strenghts: ["FSCH1", "FSCH2", "FSOL1"],
    weaknesses: ["FDOL3", "FDCH4", "FDCH3"],
  },
  imaginativePersona: {
    id: "p35",
    title: "Imaginative Persona",
    description:
      "Imaginative Personas are unique individuals who skip to their own tune in life. They pride themselves on being different to everyone else. They are carefree and fanciful, not really ever thinking about conforming to reality or they way others think. Imaginative Personas can be off on a tangent doing things their own way. They can be seen as creative, non-conforming, and complex.",
    tags: ["unconventional", "quirky", "curious", "individualistic"],
    image: "p35.svg",
    strenghts: ["FSCL1", "FSCL3", "FSOH7"],
    weaknesses: ["FDOH2", "FDOH4", "FDCL6"],
  },
  immaturePersona: {
    id: "p36",
    title: "Restless Persona",
    description:
      "Restless Personas love thrills, action, and adventure. As such, they can get restless and find it hard to concentrate in classrooms or boring office jobs. To make life more interesting, they may do things suddenly before thinking it through. They work well when they can be hands-on, active instead of passive. Others can see them as rule-avoiding, impulsive, wild, and unpredictable.",
    tags: ["flexible", "risk inclined", "shortsighted", "rash"],
    image: "p36.svg",
    strenghts: ["FSCL1", "FSCL3", "FSOL2"],
    weaknesses: ["FDOL2", "FDCL3", "FDCL5"],
  },
  clearthinkingPersona: {
    id: "p37",
    title: "Clear-Thinking Persona",
    description:
      "Clear-Thinking Personas are curious, calm, and bright. They confidently solve problems in a casual, matter-of-fact way. Others may see them as big-thinking, innovative, hard-working, and bright.",
    tags: ["creative", "intellectual", "insightful", "versatile", "inventive"],
    image: "p37.svg",
    strenghts: ["FSNL1", "FSOH5", "FSOH4"],
    weaknesses: ["FDOH3", "FDOH5", "FDNL3"],
  },
  downtoearthPersona: {
    id: "p38",
    title: "Down-To-Earth Persona",
    description:
      "Down-to-Earth Personas focus on the here and now, and stick to values that feel true to them. As they don't hold onto thoughts or past events for long, they rarely feel anxious. While some people may see them as easy-going, hands-on, and full of common sense - others may see that as being raw and comfortable with habit.",
    tags: ["calm", "composed", "traditional", "concrete"],
    image: "p38.svg",
    strenghts: ["FSNL2", "FSOL1", "FSOL3"],
    weaknesses: ["FDNL1", "FDOL1", "FDNL2"],
  },
  sensitivePersona: {
    id: "p39",
    title: "Sensitive Persona",
    description:
      "Sensitive Personas are highly curious but tend wear their heart on their sleeve. They are highly open to new experiences but can find feedback, especially negative feedback, hard to take or easily hurt by others. Their experience can strongly affect how they feel. People may see them as having big imaginations and big feelings that can be hard to understand.",
    tags: ["excitable", "passionate", "experiential"],
    image: "p39.svg",
    strenghts: ["FSNH2", "FSOH1", "FSOH7"],
    weaknesses: ["FDOH2", "FDNH4", "FDNH3"],
  },
  muddledPersona: {
    id: "p40",
    title: "Fixed Persona",
    description:
      "Fixed Personas feel safe and confident when working with things they can control and understand. If something pops up that feels beyond their reach, or that is new, it will likely cause some anxiety. To protect themselves from this anxiety, they tend to stick with things they know and do well. Others may see them as nostalgic, hesitant, lacking strong opinions about new experiences or approaches.",
    tags: ["concrete", "comfort seeking", "apprehensive", "conventional"],
    image: "p40.svg",
    strenghts: ["FSNH1", "FSOL1", "FSOL4"],
    weaknesses: ["FDOL3", "FDNH1", "FDNH2"],
  },
};

export const reporting = {
  ope: {
    high:
      "Your score on Openness to Experience is high, indicating you enjoy novelty, variety, and change. You are curious, imaginative, and creative.",
    average:
      "Your score on Openness to Experience is average, indicating you enjoy tradition but are willing to try new things. Your thinking is neither simple nor complex. You tend to balance pragmatism vs exploring new ways or 'outside of the box' thinking.",
    low:
      "Your score on Openness to Experience is low, indicating you like to think in plain and simple terms. Others describe you as pragmatic, practical, and conservative.",
    description:
      "<p>Openness to Experience describes a dimension of cognitive style that distinguishes imaginative, creative people from down-to-earth, conventional people. Open people are intellectually curious, appreciative of art, and sensitive to beauty. They tend to be, compared to closed people, more aware of their feelings. They tend to think and act in individualistic and nonconforming ways. Intellectuals typically score high on Openness to Experience; consequently, this factor has also been called Culture or Intellect. Nonetheless, Intellect is probably best regarded as one aspect of openness to experience. Scores on Openness to Experience are only modestly related to years of education and scores on standard intelligence tests.</p><p>Another characteristic of the open cognitive style is a facility for thinking in symbols and abstractions far removed from concrete experience. Depending on the individual's specific intellectual abilities, this symbolic cognition may take the form of mathematical, logical, or geometric thinking, artistic and metaphorical use of language, music composition or performance, or one of the many visual or performing arts. People with low scores on openness to experience tend to have narrow, common interests. They prefer the plain, straightforward, and obvious over the complex, ambiguous, and subtle. They may regard the arts and sciences with suspicion, regarding these endeavors as abstruse or of no practical use. Closed people prefer familiarity over novelty; they are conservative and resistant to change.</p><p>Openness is often presented as healthier or more mature by psychologists, who are often themselves open to experience. However, open and closed styles of thinking are useful in different environments. The intellectual style of the open person may serve a professor well, but research has shown that closed thinking is related to superior job performance in police work, sales, and a number of service occupations.</p>",
  },
  con: {
    high:
      "Your score on Conscientiousness is high. This means you set clear goals and pursue them with determination. People regard you as reliable and hard-working.",
    average:
      "Your score on Conscientiousness is average. This means you are reasonably reliable, organized, and self-controlled.",
    low:
      "Your score on Conscientiousness is low, indicating you like to live for the moment and do what feels good now. Your work tends to be careless and disorganized.",
    description:
      "<p>Conscientiousness concerns the way in which we control, regulate, and direct our impulses. Impulses are not inherently bad; occasionally time constraints require a snap decision, and acting on our first impulse can be an effective response. Also, in times of play rather than work, acting spontaneously and impulsively can be fun. Impulsive individuals can be seen by others as colorful, fun-to-be-with, and zany.</p><p>Nonetheless, acting on impulse can lead to trouble in a number of ways. Some impulses are antisocial. Uncontrolled antisocial acts not only harm other members of society, but also can result in retribution toward the perpetrator of such impulsive acts. Another problem with impulsive acts is that they often produce immediate rewards but undesirable, long-term consequences. Examples include excessive socializing that leads to being fired from one's job, hurling an insult that causes the breakup of an important relationship, or using pleasure-inducing drugs that eventually destroy one's health.</p><p>Impulsive behavior, even when not seriously destructive, diminishes a person's effectiveness in significant ways. Acting impulsively disallows contemplating alternative courses of action, some of which would have been wiser than the impulsive choice. Impulsivity also sidetracks people during projects that require organized sequences of steps or stages. Accomplishments of an impulsive person are therefore small, scattered, and inconsistent.</p><p>A hallmark of intelligence, what potentially separates human beings from earlier life forms, is the ability to think about future consequences before acting on an impulse. Intelligent activity involves contemplation of long-range goals, organizing and planning routes to these goals, and persisting toward one's goals in the face of short-lived impulses to the contrary. The idea that intelligence involves impulse control is nicely captured by the term prudence, an alternative label for the Conscientiousness domain. Prudent means both wise and cautious. Persons who score high on the Conscientiousness scale are, in fact, perceived by others as intelligent.</p><p>The benefits of high conscientiousness are obvious. Conscientious individuals avoid trouble and achieve high levels of success through purposeful planning and persistence. They are also positively regarded by others as intelligent and reliable. On the negative side, they can be compulsive perfectionists and workaholics. Furthermore, extremely conscientious individuals might be regarded as stuffy and boring. Unconscientious people may be criticized for their unreliability, lack of ambition, and failure to stay within the lines, but they will experience many short-lived pleasures and they will never be called stuffy.</p>",
  },
  ext: {
    high:
      "Your score on Extraversion is high, indicating you are sociable, outgoing, energetic, and lively. You prefer to be around people much of the time.",
    average:
      "Your score on Extraversion is average, indicating you are neither completely subdued nor a jovial chatterbox. You enjoy time with others but also time alone.",
    low:
      "Your score on Extraversion is low, indicating you are introverted, reserved, and quiet. You enjoy solitude and solitary activities. Your socializing tends to be restricted to a few close friends.",
    description:
      "<p>Extraversion is marked by pronounced engagement with the external world. Extroverts enjoy being with people, are full of energy, and often experience positive emotions. They tend to be enthusiastic, action-oriented, individuals who are likely to say 'Yes!' or 'Let's go!' to opportunities for excitement. In groups they like to talk, assert themselves, and draw attention to themselves.</p><p>Introverts lack the exuberance, energy, and activity levels of extraverts. They tend to be quiet, low-key, deliberate, and disengaged from the social world. Their lack of social involvement should not be interpreted as shyness or depression; the introvert simply needs less stimulation than an extravert and prefers to be alone. The independence and reserve of the introvert is sometimes mistaken as unfriendliness or arrogance. In reality, an introvert who scores high on the agreeableness dimension will not seek others out but will be quite pleasant when approached.</p>",
  },
  agr: {
    high:
      "Your high level of Agreeableness indicates a strong interest in others' needs and well-being. You are pleasant, sympathetic, and cooperative.",
    average:
      "Your level of Agreeableness is average, indicating you tend to balance concern for the needs of others and your own.",
    low:
      "Your score on Agreeableness is low, indicating that you show less concern for the needs of others than with your own. People see you as tough, critical, and uncompromising.",
    description:
      "<p>Agreeableness reflects individual differences in concern with cooperation and social harmony. Agreeable individuals value getting along with others. They are therefore considerate, friendly, generous, helpful, and willing to compromise their interests with others'. Agreeable people also have an optimistic view of human nature. They believe people are basically honest, decent, and trustworthy.</p><p>Disagreeable individuals place self-interest above getting along with others. They are generally unconcerned with others' well-being, and therefore are unlikely to extend themselves for other people. Sometimes their skepticism about others' motives causes them to be suspicious, unfriendly, and uncooperative.</p><p>Agreeableness is obviously advantageous for attaining and maintaining popularity. Agreeable people are better liked than disagreeable people. On the other hand, agreeableness is not useful in situations that require tough or absolute objective decisions. Disagreeable people can make excellent scientists, critics, or soldiers.</p>",
  },
  neu: {
    high:
      "Your score on Neuroticism is high, indicating that you are easily upset, even by what most people consider the normal demands of living. People consider you to be sensitive and emotional.",
    average:
      "Your score on Neuroticism is average, indicating that your level of emotional reactivity is typical. Stressful and frustrating situations are somewhat upsetting to you, but you are generally able to get over these feelings, move on and cope.",
    low:
      "Your score on Neuroticism is low, indicating that you are exceptionally calm, composed and unflappable. You do not react with intense emotions, even to situations that most people would describe as stressful.",
    description:
      "<p>Neuroticism can be used to describe an individual's level of mental distress, emotional suffering, and an ability to cope effectively with the normal demands of life. All individuals have varying amounts of emotionality, but we differ in our degree of suffering and our specific symptoms of distress.</p><p>Typically, Neuroticism refers to the tendency to experience negative feelings. Those who score high on Neuroticism may experience primarily one specific negative feeling such as anxiety, anger, or depression, but are likely to experience several of these emotions. People high in Neuroticism can also be emotionally reactive. They respond emotionally to events that would not affect most people, and their reactions tend to be more intense than normal. They are more likely to interpret ordinary situations as threatening, and minor frustrations as hopelessly difficult. Their negative emotional reactions tend to persist for unusually long periods of time, which means they are often in a bad mood. These problems in emotional regulation can diminish the ability to think clearly, make decisions, and cope effectively with stress.</p><p>At the other end of the scale, individuals who score low in Neuroticism are less easily upset and are less emotionally reactive. They tend to be calm, emotionally stable, and free from persistent negative feelings. Freedom from negative feelings does not mean that low scorers experience a lot of positive feelings; frequency of positive emotions is also a component of the Extraversion domain.</p>",
  },
};

export const industries = [
  { id: "1", name: "Not specified", code: "notspecified" },
  { id: "50", name: "Student", code: "student" },
  { id: "100", name: "Accounting", code: "accounting" },
  {
    id: "200",
    name: "Administration & Office Support",
    code: "administrationofficesupport",
  },
  {
    id: "300",
    name: "Advertising, Arts & Media",
    code: "advertisingartsamedia",
  },
  {
    id: "400",
    name: "Banking & Financial Services",
    code: "bankingfinancialservices",
  },
  {
    id: "500",
    name: "Call Centre & Customer Service",
    code: "callcentrecustomerservice",
  },
  {
    id: "600",
    name: "CEO & General Management",
    code: "ceogeneralmanagement",
  },
  {
    id: "700",
    name: "Community Services & Development",
    code: "communityservicesdevelopment",
  },
  { id: "800", name: "Construction", code: "construction" },
  {
    id: "900",
    name: "Consulting & Strategy",
    code: "consultingstrategy",
  },
  {
    id: "1000",
    name: "Design & Architecture",
    code: "designarchitecture",
  },
  { id: "1100", name: "Education & Training", code: "educationtraining" },
  { id: "1200", name: "Engineering", code: "engineering" },
  {
    id: "1300",
    name: "Farming, Animals & Conservation",
    code: "farminganimalsconservation",
  },
  { id: "1400", name: "Government & Defence", code: "governmentdefence" },
  { id: "1500", name: "Healthcare & Medical", code: "healthcaremedical" },
  {
    id: "1600",
    name: "Hospitality & Tourism",
    code: "hospitalitytourism",
  },
  {
    id: "1700",
    name: "Human Resources & Recruitment",
    code: "humanresourcesrecruitment",
  },
  {
    id: "1800",
    name: "Information & Communication Technology",
    code: "informationcommunicationstechnology",
  },
  {
    id: "1900",
    name: "Insurance & Superannuation",
    code: "insurancesuperannuation",
  },
  { id: "2000", name: "Legal", code: "legal" },
  {
    id: "2100",
    name: "Manufacturing, Transport & Logistics",
    code: "manufacturingtransportlogistics",
  },
  {
    id: "2200",
    name: "Marketing & Communications",
    code: "marketingcommunications",
  },
  {
    id: "2300",
    name: "Mining, Resources & Energy",
    code: "miningresourcesenergy",
  },
  {
    id: "2400",
    name: "Real Estate & Property",
    code: "realestateproperty",
  },
  {
    id: "2500",
    name: "Retail & Consumer Products",
    code: "retailconsumerproducts",
  },
  { id: "2600", name: "Sales", code: "sales" },
  { id: "2700", name: "Science & Technology", code: "sciencetechnology" },
  { id: "2800", name: "Self Employment", code: "selfemployment" },
  { id: "2900", name: "Sport & Recreation", code: "sportrecreation" },
  { id: "3000", name: "Trades & Services", code: "tradesservices" },
  { id: "3100", name: "Other", code: "otherother" },
];

export const subIndustries = [
  {
    id: "1",
    parent_id: "1",
    name: "Not specified",
    code: "notspecified",
  },
  {
    id: "51",
    parent_id: "50",
    name: "Accounting",
    code: "studentaccounting",
  },
  {
    id: "52",
    parent_id: "50",
    name: "Administration & Office Support",
    code: "studentadministrationofficesupport",
  },
  {
    id: "53",
    parent_id: "50",
    name: "Advertising, Arts & Media",
    code: "studentadvertisingartsamedia",
  },
  {
    id: "54",
    parent_id: "50",
    name: "Banking & Financial Services",
    code: "studentbankingfinancialservices",
  },
  {
    id: "55",
    parent_id: "50",
    name: "Call Centre & Customer Service",
    code: "studentcallcentrecustomerservice",
  },
  {
    id: "56",
    parent_id: "50",
    name: "CEO & General Management",
    code: "studentceogeneralmanagement",
  },
  {
    id: "57",
    parent_id: "50",
    name: "Community Services & Development",
    code: "studentcommunityservicesdevelopment",
  },
  {
    id: "58",
    parent_id: "50",
    name: "Construction",
    code: "studentconstruction",
  },
  {
    id: "59",
    parent_id: "50",
    name: "Consulting & Strategy",
    code: "studentconsultingstrategy",
  },
  {
    id: "60",
    parent_id: "50",
    name: "Design & Architecture",
    code: "studentdesignarchitecture",
  },
  {
    id: "61",
    parent_id: "50",
    name: "Education & Training",
    code: "studenteducationtraining",
  },
  {
    id: "62",
    parent_id: "50",
    name: "Engineering",
    code: "studentengineering",
  },
  {
    id: "63",
    parent_id: "50",
    name: "Farming, Animals & Conservation",
    code: "studentfarminganimalsconservation",
  },
  {
    id: "64",
    parent_id: "50",
    name: "Government & Defence",
    code: "studentgovernmentdefence",
  },
  {
    id: "65",
    parent_id: "50",
    name: "Healthcare & Medical",
    code: "studenthealthcaremedical",
  },
  {
    id: "66",
    parent_id: "50",
    name: "Hospitality & Tourism",
    code: "studenthospitalitytourism",
  },
  {
    id: "67",
    parent_id: "50",
    name: "Human Resources & Recruitment",
    code: "studenthumanresourcesrecruitment",
  },
  {
    id: "68",
    parent_id: "50",
    name: "Information & Communication Technology",
    code: "studentinformationcommunicationstechnology",
  },
  {
    id: "69",
    parent_id: "50",
    name: "Insurance & Superannuation",
    code: "studentinsurancesuperannuation",
  },
  { id: "70", parent_id: "50", name: "Legal", code: "studentlegal" },
  {
    id: "71",
    parent_id: "50",
    name: "Manufacturing, Transport & Logistics",
    code: "studentmanufacturingtransportlogistics",
  },
  {
    id: "72",
    parent_id: "50",
    name: "Marketing & Communications",
    code: "studentmarketingcommunications",
  },
  {
    id: "73",
    parent_id: "50",
    name: "Mining, Resources & Energy",
    code: "studentminingresourcesenergy",
  },
  {
    id: "74",
    parent_id: "50",
    name: "Real Estate & Property",
    code: "studentrealestateproperty",
  },
  {
    id: "75",
    parent_id: "50",
    name: "Retail & Consumer Products",
    code: "studentretailconsumerproducts",
  },
  { id: "76", parent_id: "50", name: "Sales", code: "studentsales" },
  {
    id: "77",
    parent_id: "50",
    name: "Science & Technology",
    code: "studentsciencetechnology",
  },
  {
    id: "78",
    parent_id: "50",
    name: "Sport & Recreation",
    code: "studentselfemployment",
  },
  {
    id: "79",
    parent_id: "50",
    name: "Trades & Services",
    code: "studentsportrecreation",
  },
  { id: "80", parent_id: "50", name: "Other", code: "studentother" },
  {
    id: "101",
    parent_id: "100",
    name: "Accounts Officers/Clerks",
    code: "accountsofficersclerks",
  },
  {
    id: "102",
    parent_id: "100",
    name: "Accounts Payable",
    code: "accountspayable",
  },
  {
    id: "103",
    parent_id: "100",
    name: "Accounts Receivable/Credit Control",
    code: "accountsreceivablecreditcontrol",
  },
  {
    id: "104",
    parent_id: "100",
    name: "Analysis & Reporting",
    code: "accountinganalysisreporting",
  },
  {
    id: "105",
    parent_id: "100",
    name: "Assistant Accountants",
    code: "assistantaccountants",
  },
  {
    id: "106",
    parent_id: "100",
    name: "Audit - External",
    code: "auditexternal",
  },
  {
    id: "107",
    parent_id: "100",
    name: "Audit - Internal",
    code: "auditinternal",
  },
  {
    id: "108",
    parent_id: "100",
    name: "Bookkeeping & Small Practice Accounting",
    code: "bookkeepingsmallpracticeaccounting",
  },
  {
    id: "109",
    parent_id: "100",
    name: "Business Services & Corporate Advisory",
    code: "businessservicescorporateadvisory",
  },
  {
    id: "110",
    parent_id: "100",
    name: "Company Secretaries",
    code: "companysecretaries",
  },
  {
    id: "111",
    parent_id: "100",
    name: "Compliance & Risk",
    code: "accountingcompliancerisk",
  },
  {
    id: "112",
    parent_id: "100",
    name: "Cost Accounting",
    code: "costaccounting",
  },
  {
    id: "113",
    parent_id: "100",
    name: "Financial Accounting & Reporting",
    code: "financialaccountingreporting",
  },
  {
    id: "114",
    parent_id: "100",
    name: "Financial Managers & Controllers",
    code: "financialmanagerscontrollers",
  },
  {
    id: "115",
    parent_id: "100",
    name: "Forensic Accounting & Investigation",
    code: "forensicaccountinginvestigation",
  },
  {
    id: "116",
    parent_id: "100",
    name: "Insolvency & Corporate Recovery",
    code: "insolvencycorporaterecovery",
  },
  {
    id: "117",
    parent_id: "100",
    name: "Inventory & Fixed Assets",
    code: "inventoryfixedassets",
  },
  {
    id: "118",
    parent_id: "100",
    name: "Management",
    code: "accountingmanagement",
  },
  {
    id: "119",
    parent_id: "100",
    name: "Management Accounting & Budgeting",
    code: "managementaccountingbudgeting",
  },
  { id: "121", parent_id: "100", name: "Payroll", code: "payroll" },
  {
    id: "122",
    parent_id: "100",
    name: "Strategy & Planning",
    code: "accountingstrategyplanning",
  },
  {
    id: "123",
    parent_id: "100",
    name: "Systems Accounting & IT Audit",
    code: "systemsaccountingitaudit",
  },
  { id: "124", parent_id: "100", name: "Taxation", code: "taxation" },
  {
    id: "125",
    parent_id: "100",
    name: "Treasury",
    code: "accountingtreasury",
  },
  {
    id: "126",
    parent_id: "100",
    name: "Other",
    code: "accountingother",
  },
  {
    id: "201",
    parent_id: "200",
    name: "Administrative Assistants",
    code: "administrativeassistants",
  },
  {
    id: "202",
    parent_id: "200",
    name: "Client & Sales Administration",
    code: "clientsalesadministration",
  },
  {
    id: "203",
    parent_id: "200",
    name: "Contracts Administration",
    code: "contractsadministration",
  },
  {
    id: "204",
    parent_id: "200",
    name: "Data Entry & Word Processing",
    code: "dataentrywordprocessing",
  },
  {
    id: "205",
    parent_id: "200",
    name: "Office Management",
    code: "officemanagement",
  },
  {
    id: "207",
    parent_id: "200",
    name: "PA, EA & Secretarial",
    code: "paeasecretarial",
  },
  {
    id: "208",
    parent_id: "200",
    name: "Receptionists",
    code: "receptionists",
  },
  {
    id: "209",
    parent_id: "200",
    name: "Records Management & Document Control",
    code: "recordsmanagementdocumentcontrol",
  },
  {
    id: "210",
    parent_id: "200",
    name: "Other",
    code: "administrationofficesupportother",
  },
  {
    id: "301",
    parent_id: "300",
    name: "Agency Account Management",
    code: "agencyaccountmanagement",
  },
  {
    id: "302",
    parent_id: "300",
    name: "Art Direction",
    code: "artdirection",
  },
  {
    id: "303",
    parent_id: "300",
    name: "Editing & Publishing",
    code: "editingpublishing",
  },
  {
    id: "304",
    parent_id: "300",
    name: "Event Management",
    code: "advertisingartsmediaeventmanagement",
  },
  {
    id: "305",
    parent_id: "300",
    name: "Journalism & Writing",
    code: "journalismwriting",
  },
  {
    id: "306",
    parent_id: "300",
    name: "Management",
    code: "advertisingartsmediamanagement",
  },
  {
    id: "307",
    parent_id: "300",
    name: "Media Strategy, Planning & Buying",
    code: "mediastrategyplanningbuying",
  },
  {
    id: "308",
    parent_id: "300",
    name: "Other",
    code: "advertisingartsmediaother",
  },
  {
    id: "309",
    parent_id: "300",
    name: "Performing Arts",
    code: "performingarts",
  },
  {
    id: "310",
    parent_id: "300",
    name: "Photography",
    code: "photography",
  },
  {
    id: "311",
    parent_id: "300",
    name: "Programming & Production",
    code: "programmingproduction",
  },
  {
    id: "312",
    parent_id: "300",
    name: "Promotions",
    code: "promotions",
  },
  {
    id: "401",
    parent_id: "400",
    name: "Account & Relationship Management",
    code: "bankingfinancialservicesaccountrelationshipmanagem",
  },
  {
    id: "402",
    parent_id: "400",
    name: "Analysis & Reporting",
    code: "bankingfinancialservicesanalysisreporting",
  },
  {
    id: "403",
    parent_id: "400",
    name: "Banking - Business",
    code: "bankingbusiness",
  },
  {
    id: "404",
    parent_id: "400",
    name: "Banking - Corporate & Institutional",
    code: "bankingcorporateinstitutional",
  },
  {
    id: "405",
    parent_id: "400",
    name: "Banking - Retail/Branch",
    code: "bankingretailbranch",
  },
  {
    id: "406",
    parent_id: "400",
    name: "Client Services",
    code: "clientservices",
  },
  {
    id: "407",
    parent_id: "400",
    name: "Compliance & Risk",
    code: "bankingfinancialservicescompliancerisk",
  },
  {
    id: "408",
    parent_id: "400",
    name: "Corporate Finance & Investment Banking",
    code: "corporatefinanceinvestmentbanking",
  },
  { id: "409", parent_id: "400", name: "Credit", code: "credit" },
  {
    id: "410",
    parent_id: "400",
    name: "Financial Planning",
    code: "financialplanning",
  },
  {
    id: "411",
    parent_id: "400",
    name: "Funds Management",
    code: "fundsmanagement",
  },
  {
    id: "412",
    parent_id: "400",
    name: "Management",
    code: "bankingfinancialservicesmanagement",
  },
  { id: "413", parent_id: "400", name: "Mortgages", code: "mortgages" },
  {
    id: "415",
    parent_id: "400",
    name: "Settlements",
    code: "settlements",
  },
  {
    id: "416",
    parent_id: "400",
    name: "Stockbroking & Trading",
    code: "stockbrokingtrading",
  },
  {
    id: "417",
    parent_id: "400",
    name: "Treasury",
    code: "bankingfinancialservicestreasury",
  },
  {
    id: "418",
    parent_id: "400",
    name: "Other",
    code: "bankingfinancialservicesother",
  },
  {
    id: "501",
    parent_id: "500",
    name: "Collections",
    code: "collections",
  },
  {
    id: "502",
    parent_id: "500",
    name: "Customer Service - Call Centre",
    code: "customerservicecallcentre",
  },
  {
    id: "503",
    parent_id: "500",
    name: "Customer Service - Customer Facing",
    code: "customerservicecustomerfacing",
  },
  {
    id: "504",
    parent_id: "500",
    name: "Management & Support",
    code: "managementsupport",
  },
  {
    id: "506",
    parent_id: "500",
    name: "Sales - Inbound",
    code: "salesinbound",
  },
  {
    id: "507",
    parent_id: "500",
    name: "Sales - Outbound",
    code: "salesoutbound",
  },
  {
    id: "508",
    parent_id: "500",
    name: "Supervisors/Team Leaders",
    code: "supervisorsteamleaders",
  },
  {
    id: "509",
    parent_id: "500",
    name: "Other",
    code: "callcentrecustomerserviceother",
  },
  {
    id: "601",
    parent_id: "600",
    name: "Board Appointments",
    code: "boardappointments",
  },
  { id: "602", parent_id: "600", name: "CEO", code: "ceo" },
  { id: "603", parent_id: "600", name: "COO & MD", code: "coomd" },
  {
    id: "604",
    parent_id: "600",
    name: "General/Business Unit Manager",
    code: "generalbusinessunitmanager",
  },
  {
    id: "605",
    parent_id: "600",
    name: "Other",
    code: "otherceogeneralmanagement",
  },
  {
    id: "701",
    parent_id: "700",
    name: "Aged & Disability Support",
    code: "ageddisabilitysupport",
  },
  {
    id: "702",
    parent_id: "700",
    name: "Child Welfare, Youth & Family Services",
    code: "childwelfareyouthfamilyservices",
  },
  {
    id: "703",
    parent_id: "700",
    name: "Community Development",
    code: "communitydevelopment",
  },
  {
    id: "704",
    parent_id: "700",
    name: "Employment Services",
    code: "employmentservices",
  },
  {
    id: "705",
    parent_id: "700",
    name: "Fundraising",
    code: "fundraising",
  },
  {
    id: "706",
    parent_id: "700",
    name: "Housing & Homelessness Services",
    code: "housinghomelessnessservices",
  },
  {
    id: "707",
    parent_id: "700",
    name: "Indigenous & Multicultural Services",
    code: "indigenousmulticulturalservices",
  },
  {
    id: "708",
    parent_id: "700",
    name: "Management",
    code: "communityservicesdevelopmentmanagement",
  },
  {
    id: "710",
    parent_id: "700",
    name: "Volunteer Coordination & Support",
    code: "volunteercoordinationsupport",
  },
  {
    id: "711",
    parent_id: "700",
    name: "Other",
    code: "communityservicesdevelopmentother",
  },
  {
    id: "801",
    parent_id: "800",
    name: "Contracts Management",
    code: "contractsmanagement",
  },
  {
    id: "802",
    parent_id: "800",
    name: "Estimating",
    code: "estimating",
  },
  {
    id: "803",
    parent_id: "800",
    name: "Foreperson/Supervisors",
    code: "forepersonsupervisors",
  },
  {
    id: "804",
    parent_id: "800",
    name: "Health, Safety & Environment",
    code: "constructionhealthsafetyenvironment",
  },
  {
    id: "805",
    parent_id: "800",
    name: "Management",
    code: "constructionmanagement",
  },
  {
    id: "807",
    parent_id: "800",
    name: "Planning & Scheduling",
    code: "planningscheduling",
  },
  {
    id: "808",
    parent_id: "800",
    name: "Plant & Machinery Operators",
    code: "plantmachineryoperators",
  },
  {
    id: "809",
    parent_id: "800",
    name: "Project Management",
    code: "constructionprojectmanagement",
  },
  {
    id: "810",
    parent_id: "800",
    name: "Quality Assurance & Control",
    code: "constructionqualityassurancecontrol",
  },
  {
    id: "811",
    parent_id: "800",
    name: "Surveying",
    code: "constructionsurveying",
  },
  {
    id: "812",
    parent_id: "800",
    name: "Other",
    code: "constructionother",
  },
  {
    id: "901",
    parent_id: "900",
    name: "Analysts",
    code: "consultingstrategyanalysts",
  },
  {
    id: "902",
    parent_id: "900",
    name: "Corporate Development",
    code: "corporatedevelopment",
  },
  {
    id: "903",
    parent_id: "900",
    name: "Environment & Sustainability Consulting",
    code: "environmentsustainabilityconsulting",
  },
  {
    id: "904",
    parent_id: "900",
    name: "Management & Change Consulting",
    code: "managementchangeconsulting",
  },
  { id: "906", parent_id: "900", name: "Policy", code: "policy" },
  {
    id: "907",
    parent_id: "900",
    name: "Strategy & Planning",
    code: "consultingstrategystrategyplanning",
  },
  {
    id: "908",
    parent_id: "900",
    name: "Other",
    code: "consultingstrategyother",
  },
  {
    id: "1001",
    parent_id: "1000",
    name: "Architectural Drafting",
    code: "architecturaldrafting",
  },
  {
    id: "1002",
    parent_id: "1000",
    name: "Architecture",
    code: "architecture",
  },
  {
    id: "1003",
    parent_id: "1000",
    name: "Fashion & Textile Design",
    code: "fashiontextiledesign",
  },
  {
    id: "1004",
    parent_id: "1000",
    name: "Graphic Design",
    code: "graphicdesign",
  },
  {
    id: "1005",
    parent_id: "1000",
    name: "Illustration & Animation",
    code: "illustrationanimation",
  },
  {
    id: "1006",
    parent_id: "1000",
    name: "Industrial Design",
    code: "industrialdesign",
  },
  {
    id: "1007",
    parent_id: "1000",
    name: "Interior Design",
    code: "interiordesign",
  },
  {
    id: "1008",
    parent_id: "1000",
    name: "Landscape Architecture",
    code: "landscapearchitecture",
  },
  {
    id: "1010",
    parent_id: "1000",
    name: "Urban Design & Planning",
    code: "urbandesignplanning",
  },
  {
    id: "1011",
    parent_id: "1000",
    name: "Web & Interaction Design",
    code: "webinteractiondesign",
  },
  {
    id: "1012",
    parent_id: "1000",
    name: "Other",
    code: "designarchitectureother",
  },
  {
    id: "1101",
    parent_id: "1100",
    name: "Childcare & Outside School Hours Care",
    code: "childcareoutsideschoolhourscare",
  },
  {
    id: "1102",
    parent_id: "1100",
    name: "Library Services & Information Management",
    code: "libraryservicesinformationmanagement",
  },
  {
    id: "1103",
    parent_id: "1100",
    name: "Management - Schools",
    code: "managementschools",
  },
  {
    id: "1104",
    parent_id: "1100",
    name: "Management - Universities",
    code: "managementuniversities",
  },
  {
    id: "1105",
    parent_id: "1100",
    name: "Management - Vocational",
    code: "managementvocational",
  },
  {
    id: "1107",
    parent_id: "1100",
    name: "Research & Fellowships",
    code: "researchfellowships",
  },
  {
    id: "1108",
    parent_id: "1100",
    name: "Student Services",
    code: "studentservices",
  },
  {
    id: "1109",
    parent_id: "1100",
    name: "Teaching - Early Childhood",
    code: "teachingearlychildhood",
  },
  {
    id: "1110",
    parent_id: "1100",
    name: "Teaching - Primary",
    code: "teachingprimary",
  },
  {
    id: "1111",
    parent_id: "1100",
    name: "Teaching - Secondary",
    code: "teachingsecondary",
  },
  {
    id: "1112",
    parent_id: "1100",
    name: "Teaching - Tertiary",
    code: "teachingtertiary",
  },
  {
    id: "1113",
    parent_id: "1100",
    name: "Teaching - Vocational",
    code: "teachingvocational",
  },
  {
    id: "1114",
    parent_id: "1100",
    name: "Teaching Aides & Special Needs",
    code: "teachingaidesspecialneeds",
  },
  { id: "1115", parent_id: "1100", name: "Tutoring", code: "tutoring" },
  {
    id: "1116",
    parent_id: "1100",
    name: "Workplace Training & Assessment",
    code: "workplacetrainingassessment",
  },
  {
    id: "1117",
    parent_id: "1100",
    name: "Other",
    code: "educationtrainingother",
  },
  {
    id: "1201",
    parent_id: "1200",
    name: "Aerospace Engineering",
    code: "aerospaceengineering",
  },
  {
    id: "1202",
    parent_id: "1200",
    name: "Automotive Engineering",
    code: "automotiveengineering",
  },
  {
    id: "1203",
    parent_id: "1200",
    name: "Building Services Engineering",
    code: "buildingservicesengineering",
  },
  {
    id: "1204",
    parent_id: "1200",
    name: "Chemical Engineering",
    code: "chemicalengineering",
  },
  {
    id: "1205",
    parent_id: "1200",
    name: "Civil/Structural Engineering",
    code: "civilstructuralengineering",
  },
  {
    id: "1206",
    parent_id: "1200",
    name: "Electrical/Electronic Engineering",
    code: "electricalelectronicengineering",
  },
  {
    id: "1207",
    parent_id: "1200",
    name: "Engineering Drafting",
    code: "engineeringdrafting",
  },
  {
    id: "1208",
    parent_id: "1200",
    name: "Environmental Engineering",
    code: "environmentalengineering",
  },
  {
    id: "1209",
    parent_id: "1200",
    name: "Field Engineering",
    code: "fieldengineering",
  },
  {
    id: "1210",
    parent_id: "1200",
    name: "Industrial Engineering",
    code: "industrialengineering",
  },
  {
    id: "1211",
    parent_id: "1200",
    name: "Maintenance",
    code: "engineeringmaintenance",
  },
  {
    id: "1212",
    parent_id: "1200",
    name: "Management",
    code: "engineeringmanagement",
  },
  {
    id: "1213",
    parent_id: "1200",
    name: "Materials Handling Engineering",
    code: "materialshandlingengineering",
  },
  {
    id: "1214",
    parent_id: "1200",
    name: "Mechanical Engineering",
    code: "mechanicalengineering",
  },
  {
    id: "1216",
    parent_id: "1200",
    name: "Process Engineering",
    code: "processengineering",
  },
  {
    id: "1217",
    parent_id: "1200",
    name: "Project Engineering",
    code: "projectengineering",
  },
  {
    id: "1218",
    parent_id: "1200",
    name: "Project Management",
    code: "engineeringprojectmanagement",
  },
  {
    id: "1219",
    parent_id: "1200",
    name: "Supervisors",
    code: "supervisors",
  },
  {
    id: "1220",
    parent_id: "1200",
    name: "Systems Engineering",
    code: "systemsengineering",
  },
  {
    id: "1221",
    parent_id: "1200",
    name: "Water & Waste Engineering",
    code: "waterwasteengineering",
  },
  {
    id: "1222",
    parent_id: "1200",
    name: "Other",
    code: "engineeringother",
  },
  {
    id: "1301",
    parent_id: "1300",
    name: "Agronomy & Farm Services",
    code: "agronomyfarmservices",
  },
  {
    id: "1302",
    parent_id: "1300",
    name: "Conservation, Parks & Wildlife",
    code: "conservationparkswildlife",
  },
  {
    id: "1303",
    parent_id: "1300",
    name: "Farm Labour",
    code: "farmlabour",
  },
  {
    id: "1304",
    parent_id: "1300",
    name: "Farm Management",
    code: "farmmanagement",
  },
  {
    id: "1305",
    parent_id: "1300",
    name: "Fishing & Aquaculture",
    code: "fishingaquaculture",
  },
  {
    id: "1306",
    parent_id: "1300",
    name: "Horticulture",
    code: "horticulture",
  },
  {
    id: "1308",
    parent_id: "1300",
    name: "Veterinary Services & Animal Welfare",
    code: "veterinaryservicesanimalwelfare",
  },
  {
    id: "1309",
    parent_id: "1300",
    name: "Winery & Viticulture",
    code: "wineryviticulture",
  },
  {
    id: "1310",
    parent_id: "1300",
    name: "Other",
    code: "farminganimalsconservationother",
  },
  {
    id: "1401",
    parent_id: "1400",
    name: "Air Force",
    code: "airforce",
  },
  { id: "1402", parent_id: "1400", name: "Army", code: "army" },
  {
    id: "1403",
    parent_id: "1400",
    name: "Emergency Services",
    code: "emergencyservices",
  },
  {
    id: "1404",
    parent_id: "1400",
    name: "Government",
    code: "government",
  },
  {
    id: "1405",
    parent_id: "1400",
    name: "Government - Federal",
    code: "governmentfederal",
  },
  {
    id: "1406",
    parent_id: "1400",
    name: "Government - Local",
    code: "governmentlocal",
  },
  {
    id: "1407",
    parent_id: "1400",
    name: "Government - State",
    code: "governmentstate",
  },
  {
    id: "1408",
    parent_id: "1400",
    name: "Local Government",
    code: "localgovernment",
  },
  { id: "1409", parent_id: "1400", name: "Navy", code: "navy" },
  {
    id: "1411",
    parent_id: "1400",
    name: "Police & Corrections",
    code: "policecorrections",
  },
  {
    id: "1412",
    parent_id: "1400",
    name: "Policy, Planning & Regulation",
    code: "policyplanningregulation",
  },
  {
    id: "1413",
    parent_id: "1400",
    name: "Regional Council",
    code: "regionalcouncil",
  },
  {
    id: "1414",
    parent_id: "1400",
    name: "Other",
    code: "governmentdefenceother",
  },
  {
    id: "1501",
    parent_id: "1500",
    name: "Ambulance/Paramedics",
    code: "ambulanceparamedics",
  },
  {
    id: "1502",
    parent_id: "1500",
    name: "Chiropractic & Osteopathic",
    code: "chiropracticosteopathic",
  },
  {
    id: "1503",
    parent_id: "1500",
    name: "Clinical/Medical Research",
    code: "clinicalmedicalresearch",
  },
  { id: "1504", parent_id: "1500", name: "Dental", code: "dental" },
  {
    id: "1505",
    parent_id: "1500",
    name: "Dieticians",
    code: "dieticians",
  },
  {
    id: "1506",
    parent_id: "1500",
    name: "Environmental Services",
    code: "environmentalservices",
  },
  {
    id: "1507",
    parent_id: "1500",
    name: "General Practitioners",
    code: "generalpractitioners",
  },
  {
    id: "1508",
    parent_id: "1500",
    name: "Management",
    code: "healthcaremedicalmanagement",
  },
  {
    id: "1509",
    parent_id: "1500",
    name: "Medical Administration",
    code: "medicaladministration",
  },
  {
    id: "1510",
    parent_id: "1500",
    name: "Medical Imaging",
    code: "medicalimaging",
  },
  {
    id: "1511",
    parent_id: "1500",
    name: "Medical Specialists",
    code: "medicalspecialists",
  },
  {
    id: "1512",
    parent_id: "1500",
    name: "Natural Therapies & Alternative Medicine",
    code: "naturaltherapiesalternativemedicine",
  },
  {
    id: "1513",
    parent_id: "1500",
    name: "Nursing - A&E, Critical Care & ICU",
    code: "nursingaecriticalcareicu",
  },
  {
    id: "1514",
    parent_id: "1500",
    name: "Nursing - Aged Care",
    code: "nursingagedcare",
  },
  {
    id: "1515",
    parent_id: "1500",
    name: "Nursing - Community, Maternal & Child Health",
    code: "nursingcommunitymaternalchildhealth",
  },
  {
    id: "1516",
    parent_id: "1500",
    name: "Nursing - Educators & Facilitators",
    code: "nursingeducatorsfacilitators",
  },
  {
    id: "1517",
    parent_id: "1500",
    name: "Nursing - General Medical & Surgical",
    code: "nursinggeneralmedicalsurgical",
  },
  {
    id: "1518",
    parent_id: "1500",
    name: "Nursing - High Acuity",
    code: "nursinghighacuity",
  },
  {
    id: "1519",
    parent_id: "1500",
    name: "Nursing - Management",
    code: "nursingmanagement",
  },
  {
    id: "1520",
    parent_id: "1500",
    name: "Nursing - Midwifery, Neo-Natal, SCN & NICU",
    code: "nursingmidwiferyneonatalscnnicu",
  },
  {
    id: "1521",
    parent_id: "1500",
    name: "Nursing - Paediatric & PICU",
    code: "nursingpaediatricpicu",
  },
  {
    id: "1522",
    parent_id: "1500",
    name: "Nursing - Psych, Forensic & Correctional Health",
    code: "nursingpsychforensiccorrectionalhealth",
  },
  {
    id: "1523",
    parent_id: "1500",
    name: "Nursing - Theatre & Recovery",
    code: "nursingtheatrerecovery",
  },
  { id: "1524", parent_id: "1500", name: "Optical", code: "optical" },
  {
    id: "1526",
    parent_id: "1500",
    name: "Pathology",
    code: "pathology",
  },
  {
    id: "1527",
    parent_id: "1500",
    name: "Pharmaceuticals & Medical Devices",
    code: "pharmaceuticalsmedicaldevices",
  },
  { id: "1528", parent_id: "1500", name: "Pharmacy", code: "pharmacy" },
  {
    id: "1529",
    parent_id: "1500",
    name: "Physiotherapy, OT & Rehabilitation",
    code: "physiotherapyotrehabilitation",
  },
  {
    id: "1530",
    parent_id: "1500",
    name: "Psychology, Counselling & Social Work",
    code: "psychologycounsellingsocialwork",
  },
  {
    id: "1531",
    parent_id: "1500",
    name: "Sales",
    code: "healthcaremedicalsales",
  },
  {
    id: "1532",
    parent_id: "1500",
    name: "Speech Therapy",
    code: "speechtherapy",
  },
  {
    id: "1533",
    parent_id: "1500",
    name: "Residents & Registrars",
    code: "residentsregistrars",
  },
  {
    id: "1534",
    parent_id: "1500",
    name: "Other",
    code: "healthcaremedicalother",
  },
  { id: "1601", parent_id: "1600", name: "Airlines", code: "airlines" },
  {
    id: "1602",
    parent_id: "1600",
    name: "Bar & Beverage Staff",
    code: "barbeveragestaff",
  },
  {
    id: "1603",
    parent_id: "1600",
    name: "Chefs/Cooks",
    code: "chefscooks",
  },
  {
    id: "1604",
    parent_id: "1600",
    name: "Front Office & Guest Services",
    code: "frontofficeguestservices",
  },
  { id: "1605", parent_id: "1600", name: "Gaming", code: "gaming" },
  {
    id: "1606",
    parent_id: "1600",
    name: "Housekeeping",
    code: "housekeeping",
  },
  {
    id: "1607",
    parent_id: "1600",
    name: "Kitchen & Sandwich Hands",
    code: "kitchensandwichhands",
  },
  {
    id: "1608",
    parent_id: "1600",
    name: "Management",
    code: "hospitaltourismmanagement",
  },
  {
    id: "1609",
    parent_id: "1600",
    name: "Other",
    code: "hospitaltourismother",
  },
  {
    id: "1610",
    parent_id: "1600",
    name: "Reservations",
    code: "reservations",
  },
  {
    id: "1611",
    parent_id: "1600",
    name: "Tour Guides",
    code: "tourguides",
  },
  {
    id: "1612",
    parent_id: "1600",
    name: "Travel Agents/Consultants",
    code: "travelagentsconsultants",
  },
  {
    id: "1613",
    parent_id: "1600",
    name: "Waiting Staff",
    code: "waitingstaff",
  },
  {
    id: "1701",
    parent_id: "1700",
    name: "Consulting & Generalist HR",
    code: "consultinggeneralisthr",
  },
  {
    id: "1702",
    parent_id: "1700",
    name: "Industrial & Employee Relations",
    code: "industrialemployeerelations",
  },
  {
    id: "1703",
    parent_id: "1700",
    name: "Management - Agency",
    code: "managementagency",
  },
  {
    id: "1704",
    parent_id: "1700",
    name: "Management - Internal",
    code: "managementinternal",
  },
  {
    id: "1705",
    parent_id: "1700",
    name: "Occupational Health & Safety",
    code: "occupationalhealthsafety",
  },
  {
    id: "1706",
    parent_id: "1700",
    name: "Organisational Development",
    code: "organisationaldevelopment",
  },
  {
    id: "1708",
    parent_id: "1700",
    name: "Recruitment - Agency",
    code: "recruitmentagency",
  },
  {
    id: "1709",
    parent_id: "1700",
    name: "Recruitment - Internal",
    code: "recruitmentinternal",
  },
  {
    id: "1710",
    parent_id: "1700",
    name: "Remuneration & Benefits",
    code: "remunerationbenefits",
  },
  {
    id: "1711",
    parent_id: "1700",
    name: "Training & Development",
    code: "trainingdevelopment",
  },
  {
    id: "1712",
    parent_id: "1700",
    name: "Other",
    code: "humanresourcesrecruitmentother",
  },
  {
    id: "1801",
    parent_id: "1800",
    name: "Architects",
    code: "architects",
  },
  {
    id: "1802",
    parent_id: "1800",
    name: "Business/Systems Analysts",
    code: "businesssystemsanalysts",
  },
  {
    id: "1803",
    parent_id: "1800",
    name: "Computer Operators",
    code: "computeroperators",
  },
  {
    id: "1804",
    parent_id: "1800",
    name: "Consultants",
    code: "consultants",
  },
  {
    id: "1805",
    parent_id: "1800",
    name: "Database Development & Administration",
    code: "databasedevelopmentadministration",
  },
  {
    id: "1806",
    parent_id: "1800",
    name: "Developers/Programmers",
    code: "developersprogrammers",
  },
  {
    id: "1807",
    parent_id: "1800",
    name: "Engineering - Hardware",
    code: "engineeringhardware",
  },
  {
    id: "1808",
    parent_id: "1800",
    name: "Engineering - Network",
    code: "engineeringnetwork",
  },
  {
    id: "1809",
    parent_id: "1800",
    name: "Engineering - Software",
    code: "engineeringsoftware",
  },
  {
    id: "1810",
    parent_id: "1800",
    name: "Help Desk & IT Support",
    code: "helpdeskitsupport",
  },
  {
    id: "1811",
    parent_id: "1800",
    name: "Management",
    code: "informationcommunicationtechnologymanagement",
  },
  {
    id: "1812",
    parent_id: "1800",
    name: "Networks & Systems Administration",
    code: "networkssystemsadministration",
  },
  {
    id: "1814",
    parent_id: "1800",
    name: "Product Management & Development",
    code: "informationcommunicationtechnologyproductmanagemen",
  },
  {
    id: "1815",
    parent_id: "1800",
    name: "Programme & Project Management",
    code: "programmeprojectmanagement",
  },
  {
    id: "1816",
    parent_id: "1800",
    name: "Sales - Pre & Post",
    code: "salesprepost",
  },
  { id: "1817", parent_id: "1800", name: "Security", code: "security" },
  {
    id: "1818",
    parent_id: "1800",
    name: "Team Leaders",
    code: "teamleaders",
  },
  {
    id: "1819",
    parent_id: "1800",
    name: "Technical Writing",
    code: "technicalwriting",
  },
  {
    id: "1820",
    parent_id: "1800",
    name: "Telecommunications",
    code: "telecommunications",
  },
  {
    id: "1821",
    parent_id: "1800",
    name: "Testing & Quality Assurance",
    code: "testingqualityassurance",
  },
  {
    id: "1822",
    parent_id: "1800",
    name: "Web Development & Production",
    code: "webdevelopmentproduction",
  },
  {
    id: "1823",
    parent_id: "1800",
    name: "Other",
    code: "informationcommunicationtechnologyother",
  },
  {
    id: "1901",
    parent_id: "1900",
    name: "Actuarial",
    code: "actuarial",
  },
  {
    id: "1902",
    parent_id: "1900",
    name: "Assessment",
    code: "assessment",
  },
  {
    id: "1903",
    parent_id: "1900",
    name: "Brokerage",
    code: "brokerage",
  },
  { id: "1904", parent_id: "1900", name: "Claims", code: "claims" },
  {
    id: "1905",
    parent_id: "1900",
    name: "Fund Administration",
    code: "fundadministration",
  },
  {
    id: "1906",
    parent_id: "1900",
    name: "Management",
    code: "insurancesuperannuationmanagement",
  },
  {
    id: "1908",
    parent_id: "1900",
    name: "Risk Consulting",
    code: "riskconsulting",
  },
  {
    id: "1909",
    parent_id: "1900",
    name: "Superannuation",
    code: "superannuation",
  },
  {
    id: "1910",
    parent_id: "1900",
    name: "Underwriting",
    code: "underwriting",
  },
  {
    id: "1911",
    parent_id: "1900",
    name: "Workers Compensation",
    code: "workerscompensation",
  },
  {
    id: "1912",
    parent_id: "1900",
    name: "Other",
    code: "insurancesuperannuationother",
  },
  {
    id: "2001",
    parent_id: "2000",
    name: "Banking & Finance Law",
    code: "bankingfinancelaw",
  },
  {
    id: "2002",
    parent_id: "2000",
    name: "Construction Law",
    code: "constructionlaw",
  },
  {
    id: "2003",
    parent_id: "2000",
    name: "Corporate & Commercial Law",
    code: "corporatecommerciallaw",
  },
  {
    id: "2004",
    parent_id: "2000",
    name: "Criminal & Civil Law",
    code: "criminalcivillaw",
  },
  {
    id: "2005",
    parent_id: "2000",
    name: "Environment & Planning Law",
    code: "environmentplanninglaw",
  },
  {
    id: "2006",
    parent_id: "2000",
    name: "Family Law",
    code: "familylaw",
  },
  {
    id: "2007",
    parent_id: "2000",
    name: "Generalists - In-house",
    code: "generalistsinhouse",
  },
  {
    id: "2008",
    parent_id: "2000",
    name: "Generalists - Law Firm",
    code: "generalistslawfirm",
  },
  {
    id: "2009",
    parent_id: "2000",
    name: "Industrial Relations & Employment Law",
    code: "industrialrelationsemploymentlaw",
  },
  {
    id: "2010",
    parent_id: "2000",
    name: "Insurance & Superannuation Law",
    code: "insurancesuperannuationlaw",
  },
  {
    id: "2011",
    parent_id: "2000",
    name: "Intellectual Property Law",
    code: "intellectualpropertylaw",
  },
  {
    id: "2012",
    parent_id: "2000",
    name: "Law Clerks & Paralegals",
    code: "lawclerksparalegals",
  },
  {
    id: "2013",
    parent_id: "2000",
    name: "Legal Practice Management",
    code: "legalpracticemanagement",
  },
  {
    id: "2014",
    parent_id: "2000",
    name: "Legal Secretaries",
    code: "legalsecretaries",
  },
  {
    id: "2015",
    parent_id: "2000",
    name: "Litigation & Dispute Resolution",
    code: "litigationdisputeresolution",
  },
  {
    id: "2017",
    parent_id: "2000",
    name: "Personal Injury Law",
    code: "personalinjurylaw",
  },
  {
    id: "2018",
    parent_id: "2000",
    name: "Property Law",
    code: "propertylaw",
  },
  { id: "2019", parent_id: "2000", name: "Tax Law", code: "taxlaw" },
  { id: "2020", parent_id: "2000", name: "Other", code: "legalother" },
  {
    id: "2101",
    parent_id: "2100",
    name: "Analysis & Reporting",
    code: "manufacturingtransportlogisticsanalysisreporting",
  },
  {
    id: "2102",
    parent_id: "2100",
    name: "Assembly & Process Work",
    code: "assemblyprocesswork",
  },
  {
    id: "2103",
    parent_id: "2100",
    name: "Aviation Services",
    code: "aviationservices",
  },
  {
    id: "2104",
    parent_id: "2100",
    name: "Courier, Drivers & Postal Services",
    code: "couriersdriverspostalservices",
  },
  {
    id: "2105",
    parent_id: "2100",
    name: "Fleet Management",
    code: "fleetmanagement",
  },
  {
    id: "2106",
    parent_id: "2100",
    name: "Freight/Cargo Forwarding",
    code: "freightcargoforwarding",
  },
  {
    id: "2107",
    parent_id: "2100",
    name: "Import/Export & Customs",
    code: "importexportcustoms",
  },
  {
    id: "2108",
    parent_id: "2100",
    name: "Machine Operators",
    code: "machineoperators",
  },
  {
    id: "2109",
    parent_id: "2100",
    name: "Management",
    code: "manufacturingtransportlogisticsmanagement",
  },
  {
    id: "2111",
    parent_id: "2100",
    name: "Pattern Makers & Garment Technicians",
    code: "patternmakersgarmenttechnicians",
  },
  {
    id: "2112",
    parent_id: "2100",
    name: "Pickers & Packers",
    code: "pickerspackers",
  },
  {
    id: "2113",
    parent_id: "2100",
    name: "Purchasing, Procurement & Inventory",
    code: "purchasingprocurementinventory",
  },
  {
    id: "2114",
    parent_id: "2100",
    name: "Production, Planning & Scheduling",
    code: "productionplanningscheduling",
  },
  {
    id: "2115",
    parent_id: "2100",
    name: "Public Transport & Taxi Services",
    code: "publictransporttaxiservices",
  },
  {
    id: "2116",
    parent_id: "2100",
    name: "Quality Assurance & Control",
    code: "manufacturingtransportlogisticsqualityassurance",
  },
  {
    id: "2117",
    parent_id: "2100",
    name: "Rail & Maritime Transport",
    code: "railmaritimetransport",
  },
  {
    id: "2118",
    parent_id: "2100",
    name: "Road Transport",
    code: "roadtransport",
  },
  {
    id: "2119",
    parent_id: "2100",
    name: "Team Leaders/Supervisors",
    code: "teamleaderssupervisors",
  },
  {
    id: "2120",
    parent_id: "2100",
    name: "Warehousing, Storage & Distribution",
    code: "warehousingstoragedistribution",
  },
  {
    id: "2121",
    parent_id: "2100",
    name: "Other",
    code: "manufacturingtransportlogisticsother",
  },
  {
    id: "2201",
    parent_id: "2200",
    name: "Brand Management",
    code: "brandmanagement",
  },
  {
    id: "2202",
    parent_id: "2200",
    name: "Digital & Search Marketing",
    code: "digitalsearchmarketing",
  },
  {
    id: "2203",
    parent_id: "2200",
    name: "Direct Marketing & CRM",
    code: "directmarketingcrm",
  },
  {
    id: "2204",
    parent_id: "2200",
    name: "Event Management",
    code: "marketingcommunicationseventmanagement",
  },
  {
    id: "2205",
    parent_id: "2200",
    name: "Internal Communications",
    code: "internalcommunications",
  },
  {
    id: "2206",
    parent_id: "2200",
    name: "Management",
    code: "marketingcommunicationsmanagement",
  },
  {
    id: "2207",
    parent_id: "2200",
    name: "Market Research & Analysis",
    code: "marketresearchanalysis",
  },
  {
    id: "2208",
    parent_id: "2200",
    name: "Marketing Assistants/Coordinators",
    code: "marketingassistantscoordinators",
  },
  {
    id: "2209",
    parent_id: "2200",
    name: "Marketing Communications",
    code: "marketingcommunications",
  },
  {
    id: "2211",
    parent_id: "2200",
    name: "Product Management & Development",
    code: "marketingcommunicationsproductmanagementdevelopmen",
  },
  {
    id: "2212",
    parent_id: "2200",
    name: "Public Relations & Corporate Affairs",
    code: "publicrelationscorporateaffairs",
  },
  {
    id: "2213",
    parent_id: "2200",
    name: "Trade Marketing",
    code: "trademarketing",
  },
  {
    id: "2214",
    parent_id: "2200",
    name: "Other",
    code: "marketingcommunicationsother",
  },
  {
    id: "2301",
    parent_id: "2300",
    name: "Analysis & Reporting",
    code: "miningresourcesenergyanalysisreporting",
  },
  {
    id: "2302",
    parent_id: "2300",
    name: "Health, Safety & Environment",
    code: "miningresourcesenergyhealthsafetyenvironment",
  },
  {
    id: "2303",
    parent_id: "2300",
    name: "Management",
    code: "miningresourcesenergymanagement",
  },
  {
    id: "2304",
    parent_id: "2300",
    name: "Mining - Drill & Blast",
    code: "miningdrillblast",
  },
  {
    id: "2305",
    parent_id: "2300",
    name: "Mining - Engineering & Maintenance",
    code: "miningengineeringmaintenance",
  },
  {
    id: "2306",
    parent_id: "2300",
    name: "Mining - Exploration & Geoscience",
    code: "miningexplorationgeoscience",
  },
  {
    id: "2307",
    parent_id: "2300",
    name: "Mining - Operations",
    code: "miningoperations",
  },
  {
    id: "2308",
    parent_id: "2300",
    name: "Mining - Processing",
    code: "miningprocessing",
  },
  {
    id: "2309",
    parent_id: "2300",
    name: "Natural Resources & Water",
    code: "naturalresourceswater",
  },
  {
    id: "2310",
    parent_id: "2300",
    name: "Oil & Gas - Drilling",
    code: "oilgasdrilling",
  },
  {
    id: "2311",
    parent_id: "2300",
    name: "Oil & Gas - Engineering & Maintenance",
    code: "oilgasengineeringmaintenance",
  },
  {
    id: "2312",
    parent_id: "2300",
    name: "Oil & Gas - Exploration & Geoscience",
    code: "oilgasexplorationgeoscience",
  },
  {
    id: "2313",
    parent_id: "2300",
    name: "Oil & Gas - Operations",
    code: "oilgasoperations",
  },
  {
    id: "2314",
    parent_id: "2300",
    name: "Oil & Gas - Production & Refinement",
    code: "oilgasproductionrefinement",
  },
  {
    id: "2316",
    parent_id: "2300",
    name: "Power Generation & Distribution",
    code: "powergenerationdistribution",
  },
  {
    id: "2317",
    parent_id: "2300",
    name: "Surveying",
    code: "miningresourcesenergysurveying",
  },
  {
    id: "2318",
    parent_id: "2300",
    name: "Other",
    code: "miningresourcesenergyother",
  },
  {
    id: "2401",
    parent_id: "2400",
    name: "Analysts",
    code: "realestatepropertyanalysts",
  },
  {
    id: "2402",
    parent_id: "2400",
    name: "Body Corporate & Facilities Management",
    code: "bodycorporatefacilitiesmanagement",
  },
  {
    id: "2403",
    parent_id: "2400",
    name: "Commercial Sales, Leasing & Property Mgmt",
    code: "commercialsalesleasingpropertymgmt",
  },
  {
    id: "2405",
    parent_id: "2400",
    name: "Residential Leasing & Property Management",
    code: "residentialleasingpropertymanagement",
  },
  {
    id: "2406",
    parent_id: "2400",
    name: "Residential Sales",
    code: "residentialsales",
  },
  {
    id: "2407",
    parent_id: "2400",
    name: "Retail & Property Development",
    code: "retailpropertydevelopment",
  },
  {
    id: "2408",
    parent_id: "2400",
    name: "Valuation",
    code: "valuation",
  },
  {
    id: "2409",
    parent_id: "2400",
    name: "Administration",
    code: "realestatepropertyadministration",
  },
  {
    id: "2410",
    parent_id: "2400",
    name: "Other",
    code: "realestatepropertyother",
  },
  { id: "2501", parent_id: "2500", name: "Buying", code: "buying" },
  {
    id: "2502",
    parent_id: "2500",
    name: "Management - Area/Multi-site",
    code: "managementareamultisite",
  },
  {
    id: "2503",
    parent_id: "2500",
    name: "Management - Department/Assistant",
    code: "managementdepartmentassistant",
  },
  {
    id: "2504",
    parent_id: "2500",
    name: "Management - Store",
    code: "managementstore",
  },
  {
    id: "2505",
    parent_id: "2500",
    name: "Merchandisers",
    code: "merchandisers",
  },
  { id: "2507", parent_id: "2500", name: "Planning", code: "planning" },
  {
    id: "2508",
    parent_id: "2500",
    name: "Retail Assistants",
    code: "retailassistants",
  },
  {
    id: "2509",
    parent_id: "2500",
    name: "Other",
    code: "retailconsumerproductsother",
  },
  {
    id: "2601",
    parent_id: "2600",
    name: "Account & Relationship Management",
    code: "salesaccountrelationshipmanagement",
  },
  {
    id: "2602",
    parent_id: "2600",
    name: "Analysis & Reporting",
    code: "salesanalysisreporting",
  },
  {
    id: "2603",
    parent_id: "2600",
    name: "Management",
    code: "salesmanagement",
  },
  {
    id: "2604",
    parent_id: "2600",
    name: "New Business Development",
    code: "newbusinessdevelopment",
  },
  {
    id: "2606",
    parent_id: "2600",
    name: "Sales Coordinators",
    code: "salescoordinators",
  },
  {
    id: "2607",
    parent_id: "2600",
    name: "Sales Representatives/Consultants",
    code: "salesrepresentativesconsultants",
  },
  { id: "2608", parent_id: "2600", name: "Other", code: "salesother" },
  {
    id: "2701",
    parent_id: "2700",
    name: "Biological & Biomedical Sciences",
    code: "biologicalbiomedicalsciences",
  },
  {
    id: "2702",
    parent_id: "2700",
    name: "Biotechnology & Genetics",
    code: "biotechnologygenetics",
  },
  {
    id: "2703",
    parent_id: "2700",
    name: "Chemistry & Physics",
    code: "chemistryphysics",
  },
  {
    id: "2704",
    parent_id: "2700",
    name: "Environmental, Earth & Geosciences",
    code: "environmentalearthgeosciences",
  },
  {
    id: "2705",
    parent_id: "2700",
    name: "Food Technology & Safety",
    code: "foodtechnologysafety",
  },
  {
    id: "2706",
    parent_id: "2700",
    name: "Laboratory & Technical Services",
    code: "laboratorytechnicalservices",
  },
  {
    id: "2707",
    parent_id: "2700",
    name: "Materials Sciences",
    code: "materialssciences",
  },
  {
    id: "2708",
    parent_id: "2700",
    name: "Mathematics, Statistics & Information Sciences",
    code: "mathematicsstatisticsinformationsciences",
  },
  {
    id: "2709",
    parent_id: "2700",
    name: "Modelling & Simulation",
    code: "modellingsimulation",
  },
  {
    id: "2711",
    parent_id: "2700",
    name: "Quality Assurance & Control",
    code: "sciencetechnologyqualityassurancecontrol",
  },
  {
    id: "2712",
    parent_id: "2700",
    name: "Other",
    code: "sciencetechnologyother",
  },
  {
    id: "2801",
    parent_id: "2800",
    name: "Self Employment",
    code: "selfemployment",
  },
  {
    id: "2901",
    parent_id: "2900",
    name: "Coaching & Instruction",
    code: "coachinginstruction",
  },
  {
    id: "2902",
    parent_id: "2900",
    name: "Fitness & Personal Training",
    code: "fitnesspersonaltraining",
  },
  {
    id: "2903",
    parent_id: "2900",
    name: "Management",
    code: "sportrecreationmanagement",
  },
  {
    id: "2904",
    parent_id: "2900",
    name: "Other",
    code: "sportrecreationother",
  },
  {
    id: "3001",
    parent_id: "3000",
    name: "Air Conditioning & Refrigeration",
    code: "airconditioningrefrigeration",
  },
  {
    id: "3002",
    parent_id: "3000",
    name: "Automotive Trades",
    code: "automotivetrades",
  },
  {
    id: "3003",
    parent_id: "3000",
    name: "Bakers & Pastry Chefs",
    code: "bakerspastrychefs",
  },
  {
    id: "3004",
    parent_id: "3000",
    name: "Building Trades",
    code: "buildingtrades",
  },
  { id: "3005", parent_id: "3000", name: "Butchers", code: "butchers" },
  {
    id: "3006",
    parent_id: "3000",
    name: "Carpentry & Cabinet Making",
    code: "carpentrycabinetmaking",
  },
  {
    id: "3007",
    parent_id: "3000",
    name: "Cleaning Services",
    code: "cleaningservices",
  },
  {
    id: "3008",
    parent_id: "3000",
    name: "Electricians",
    code: "electricians",
  },
  {
    id: "3009",
    parent_id: "3000",
    name: "Fitters, Turners & Machinists",
    code: "fittersturnersmachinists",
  },
  {
    id: "3010",
    parent_id: "3000",
    name: "Floristry",
    code: "floristry",
  },
  {
    id: "3011",
    parent_id: "3000",
    name: "Gardening & Landscaping",
    code: "gardeninglandscaping",
  },
  {
    id: "3012",
    parent_id: "3000",
    name: "Hair & Beauty Services",
    code: "hairbeautyservices",
  },
  {
    id: "3013",
    parent_id: "3000",
    name: "Labourers",
    code: "labourers",
  },
  {
    id: "3014",
    parent_id: "3000",
    name: "Locksmiths",
    code: "locksmiths",
  },
  {
    id: "3015",
    parent_id: "3000",
    name: "Maintenance & Handyperson Services",
    code: "maintenancehandypersonservices",
  },
  {
    id: "3016",
    parent_id: "3000",
    name: "Nannies & Babysitters",
    code: "nanniesbabysitters",
  },
  {
    id: "3018",
    parent_id: "3000",
    name: "Painters & Sign Writers",
    code: "painterssignwriters",
  },
  { id: "3019", parent_id: "3000", name: "Plumbers", code: "plumbers" },
  {
    id: "3020",
    parent_id: "3000",
    name: "Printing & Publishing Services",
    code: "printingpublishingservices",
  },
  {
    id: "3021",
    parent_id: "3000",
    name: "Security Services",
    code: "securityservices",
  },
  {
    id: "3022",
    parent_id: "3000",
    name: "Tailors & Dressmakers",
    code: "tailorsdressmakers",
  },
  {
    id: "3023",
    parent_id: "3000",
    name: "Technicians",
    code: "technicians",
  },
  {
    id: "3024",
    parent_id: "3000",
    name: "Welders & Boilermakers",
    code: "weldersboilermakers",
  },
  {
    id: "3025",
    parent_id: "3000",
    name: "Other",
    code: "tradesservicesother",
  },
  { id: "3101", parent_id: "3100", name: "Other", code: "otherother" },
];

export const countries = [
  {
    name: "Afghanistan",
    cca2: "af",
    code: 93,
  },
  {
    name: "Albania",
    cca2: "al",
    code: 355,
  },
  {
    name: "Algeria",
    cca2: "dz",
    code: 213,
  },
  {
    name: "American Samoa",
    cca2: "as",
    code: 1684,
  },
  {
    name: "Andorra",
    cca2: "ad",
    code: 376,
  },
  {
    name: "Angola",
    cca2: "ao",
    code: 244,
  },
  {
    name: "Anguilla",
    cca2: "ai",
    code: 1264,
  },
  {
    name: "Antigua and Barbuda",
    cca2: "ag",
    code: 1268,
  },
  {
    name: "Argentina",
    cca2: "ar",
    code: 54,
  },
  {
    name: "Armenia",
    cca2: "am",
    code: 374,
  },
  {
    name: "Aruba",
    cca2: "aw",
    code: 297,
  },
  {
    name: "Australia",
    cca2: "au",
    code: 61,
  },
  {
    name: "Austria",
    cca2: "at",
    code: 43,
  },
  {
    name: "Azerbaijan",
    cca2: "az",
    code: 994,
  },
  {
    name: "Bahamas",
    cca2: "bs",
    code: 1242,
  },
  {
    name: "Bahrain",
    cca2: "bh",
    code: 973,
  },
  {
    name: "Bangladesh",
    cca2: "bd",
    code: 880,
  },
  {
    name: "Barbados",
    cca2: "bb",
    code: 1246,
  },
  {
    name: "Belarus",
    cca2: "by",
    code: 375,
  },
  {
    name: "Belgium",
    cca2: "be",
    code: 32,
  },
  {
    name: "Belize",
    cca2: "bz",
    code: 501,
  },
  {
    name: "Benin",
    cca2: "bj",
    code: 229,
  },
  {
    name: "Bermuda",
    cca2: "bm",
    code: 1441,
  },
  {
    name: "Bhutan",
    cca2: "bt",
    code: 975,
  },
  {
    name: "Bolivia",
    cca2: "bo",
    code: 591,
  },
  {
    name: "Bosnia and Herzegovina",
    cca2: "ba",
    code: 387,
  },
  {
    name: "Botswana",
    cca2: "bw",
    code: 267,
  },
  {
    name: "Brazil",
    cca2: "br",
    code: 55,
  },
  {
    name: "Brunei Darussalam",
    cca2: "bn",
    code: 673,
  },
  {
    name: "Bulgaria",
    cca2: "bg",
    code: 359,
  },
  {
    name: "Burkina Faso",
    cca2: "bf",
    code: 226,
  },
  {
    name: "Burundi",
    cca2: "bi",
    code: 257,
  },
  {
    name: "Cambodia",
    cca2: "kh",
    code: 855,
  },
  {
    name: "Cameroon",
    cca2: "cm",
    code: 237,
  },
  {
    name: "Canada",
    cca2: "ca",
    code: 1,
  },
  {
    name: "Cape Verde",
    cca2: "cv",
    code: 238,
  },
  {
    name: "Cayman Islands",
    cca2: "ky",
    code: 1345,
  },
  {
    name: "Central African Republic",
    cca2: "cf",
    code: 236,
  },
  {
    name: "Chad",
    cca2: "td",
    code: 235,
  },
  {
    name: "Chile",
    cca2: "cl",
    code: 56,
  },
  {
    name: "China",
    cca2: "cn",
    code: 86,
  },
  {
    name: "Colombia",
    cca2: "co",
    code: 57,
  },
  {
    name: "Comoros",
    cca2: "km",
    code: 269,
  },
  {
    name: "Congo (DRC)",
    cca2: "cd",
    code: 243,
  },
  {
    name: "Congo (Republic)",
    cca2: "cg",
    code: 242,
  },
  {
    name: "Cook Islands",
    cca2: "ck",
    code: 682,
  },
  {
    name: "Costa Rica",
    cca2: "cr",
    code: 506,
  },
  {
    name: "Ivory Coast",
    cca2: "ci",
    code: 225,
  },
  {
    name: "Croatia",
    cca2: "hr",
    code: 385,
  },
  {
    name: "Cuba",
    cca2: "cu",
    code: 53,
  },
  {
    name: "Cyprus",
    cca2: "cy",
    code: 357,
  },
  {
    name: "Czech Republic",
    cca2: "cz",
    code: 420,
  },
  {
    name: "Denmark",
    cca2: "dk",
    code: 45,
  },
  {
    name: "Djibouti",
    cca2: "dj",
    code: 253,
  },
  {
    name: "Dominica",
    cca2: "dm",
    code: 1767,
  },
  {
    name: "Dominican Republic",
    cca2: "do",
    code: 1809,
  },
  {
    name: "Ecuador",
    cca2: "ec",
    code: 593,
  },
  {
    name: "Egypt",
    cca2: "eg",
    code: 20,
  },
  {
    name: "El Salvador",
    cca2: "sv",
    code: 503,
  },
  {
    name: "Equatorial Guinea",
    cca2: "gq",
    code: 240,
  },
  {
    name: "Eritrea",
    cca2: "er",
    code: 291,
  },
  {
    name: "Estonia",
    cca2: "ee",
    code: 372,
  },
  {
    name: "Ethiopia",
    cca2: "et",
    code: 251,
  },
  {
    name: "Faroe Islands",
    cca2: "fo",
    code: 298,
  },
  {
    name: "Fiji",
    cca2: "fj",
    code: 679,
  },
  {
    name: "Finland",
    cca2: "fi",
    code: 358,
  },
  {
    name: "France",
    cca2: "fr",
    code: 33,
  },
  {
    name: "French Polynesia",
    cca2: "pf",
    code: 689,
  },
  {
    name: "Gabon",
    cca2: "ga",
    code: 241,
  },
  {
    name: "Gambia",
    cca2: "gm",
    code: 220,
  },
  {
    name: "Georgia",
    cca2: "ge",
    code: 995,
  },
  {
    name: "Germany",
    cca2: "de",
    code: 49,
  },
  {
    name: "Ghana",
    cca2: "gh",
    code: 233,
  },
  {
    name: "Gibraltar",
    cca2: "gi",
    code: 350,
  },
  {
    name: "Greece",
    cca2: "gr",
    code: 30,
  },
  {
    name: "Greenland",
    cca2: "gl",
    code: 299,
  },
  {
    name: "Grenada",
    cca2: "gd",
    code: 1473,
  },
  {
    name: "Guadeloupe",
    cca2: "gp",
    code: 590,
  },
  {
    name: "Guam",
    cca2: "gu",
    code: 1671,
  },
  {
    name: "Guatemala",
    cca2: "gt",
    code: 502,
  },
  {
    name: "Guernsey",
    cca2: "gg",
    code: 44,
  },
  {
    name: "Guinea",
    cca2: "gn",
    code: 224,
  },
  {
    name: "Guinea-Bissau",
    cca2: "gw",
    code: 245,
  },
  {
    name: "Guyana",
    cca2: "gy",
    code: 592,
  },
  {
    name: "Haiti",
    cca2: "ht",
    code: 509,
  },
  {
    name: "Honduras",
    cca2: "hn",
    code: 504,
  },
  {
    name: "Hong Kong",
    cca2: "hk",
    code: 852,
  },
  {
    name: "Hungary",
    cca2: "hu",
    code: 36,
  },
  {
    name: "Iceland",
    cca2: "is",
    code: 354,
  },
  {
    name: "India",
    cca2: "in",
    code: 91,
  },
  {
    name: "Indonesia",
    cca2: "id",
    code: 62,
  },
  {
    name: "Iran",
    cca2: "ir",
    code: 98,
  },
  {
    name: "Iraq",
    cca2: "iq",
    code: 964,
  },
  {
    name: "Ireland",
    cca2: "ie",
    code: 353,
  },
  {
    name: "Isle of Man",
    cca2: "im",
    code: 44,
  },
  {
    name: "Israel",
    cca2: "il",
    code: 972,
  },
  {
    name: "Italy",
    cca2: "it",
    code: 39,
  },
  {
    name: "Jamaica",
    cca2: "jm",
    code: 1876,
  },
  {
    name: "Japan",
    cca2: "jp",
    code: 81,
  },
  {
    name: "Jersey",
    cca2: "je",
    code: 44,
  },
  {
    name: "Jordan",
    cca2: "jo",
    code: 962,
  },
  {
    name: "Kazakhstan",
    cca2: "kz",
    code: 7,
  },
  {
    name: "Kenya",
    cca2: "ke",
    code: 254,
  },
  {
    name: "Kiribati",
    cca2: "ki",
    code: 686,
  },
  {
    name: "Kuwait",
    cca2: "kw",
    code: 965,
  },
  {
    name: "Kyrgyzstan",
    cca2: "kg",
    code: 996,
  },
  {
    name: "Laos",
    cca2: "la",
    code: 856,
  },
  {
    name: "Latvia",
    cca2: "lv",
    code: 371,
  },
  {
    name: "Lebanon",
    cca2: "lb",
    code: 961,
  },
  {
    name: "Lesotho",
    cca2: "ls",
    code: 266,
  },
  {
    name: "Liberia",
    cca2: "lr",
    code: 231,
  },
  {
    name: "Libya",
    cca2: "ly",
    code: 218,
  },
  {
    name: "Liechtenstein",
    cca2: "li",
    code: 423,
  },
  {
    name: "Lithuania",
    cca2: "lt",
    code: 370,
  },
  {
    name: "Luxembourg",
    cca2: "lu",
    code: 352,
  },
  {
    name: "Macao",
    cca2: "mo",
    code: 853,
  },
  {
    name: "Macedonia",
    cca2: "mk",
    code: 389,
  },
  {
    name: "Madagascar",
    cca2: "mg",
    code: 261,
  },
  {
    name: "Malawi",
    cca2: "mw",
    code: 265,
  },
  {
    name: "Malaysia",
    cca2: "my",
    code: 60,
  },
  {
    name: "Maldives",
    cca2: "mv",
    code: 960,
  },
  {
    name: "Mali",
    cca2: "ml",
    code: 223,
  },
  {
    name: "Malta",
    cca2: "mt",
    code: 356,
  },
  {
    name: "Marshall Islands",
    cca2: "mh",
    code: 692,
  },
  {
    name: "Martinique",
    cca2: "mq",
    code: 596,
  },
  {
    name: "Mauritania",
    cca2: "mr",
    code: 222,
  },
  {
    name: "Mauritius",
    cca2: "mu",
    code: 230,
  },
  {
    name: "Mexico",
    cca2: "mx",
    code: 52,
  },
  {
    name: "Micronesia",
    cca2: "fm",
    code: 691,
  },
  {
    name: "Moldova",
    cca2: "md",
    code: 373,
  },
  {
    name: "Monaco",
    cca2: "mc",
    code: 377,
  },
  {
    name: "Mongolia",
    cca2: "mn",
    code: 976,
  },
  {
    name: "Montenegro",
    cca2: "me",
    code: 382,
  },
  {
    name: "Montserrat",
    cca2: "ms",
    code: 1664,
  },
  {
    name: "Morocco",
    cca2: "ma",
    code: 212,
  },
  {
    name: "Mozambique",
    cca2: "mz",
    code: 258,
  },
  {
    name: "Myanmar (Burma)",
    cca2: "mm",
    code: 95,
  },
  {
    name: "Namibia",
    cca2: "na",
    code: 264,
  },
  {
    name: "Nauru",
    cca2: "nr",
    code: 674,
  },
  {
    name: "Nepal",
    cca2: "np",
    code: 977,
  },
  {
    name: "Netherlands",
    cca2: "nl",
    code: 31,
  },
  {
    name: "New Caledonia",
    cca2: "nc",
    code: 687,
  },
  {
    name: "New Zealand",
    cca2: "nz",
    code: 64,
  },
  {
    name: "Nicaragua",
    cca2: "ni",
    code: 505,
  },
  {
    name: "Niger",
    cca2: "ne",
    code: 227,
  },
  {
    name: "Nigeria",
    cca2: "ng",
    code: 234,
  },
  {
    name: "North Korea",
    cca2: "kp",
    code: 850,
  },
  {
    name: "Norway",
    cca2: "no",
    code: 47,
  },
  {
    name: "Oman",
    cca2: "om",
    code: 968,
  },
  {
    name: "Pakistan",
    cca2: "pk",
    code: 92,
  },
  {
    name: "Palau",
    cca2: "pw",
    code: 680,
  },
  {
    name: "Palestinian Territory",
    cca2: "ps",
    code: 970,
  },
  {
    name: "Panama",
    cca2: "pa",
    code: 507,
  },
  {
    name: "Papua New Guinea",
    cca2: "pg",
    code: 675,
  },
  {
    name: "Paraguay",
    cca2: "py",
    code: 595,
  },
  {
    name: "Peru",
    cca2: "pe",
    code: 51,
  },
  {
    name: "Philippines",
    cca2: "ph",
    code: 63,
  },
  {
    name: "Poland",
    cca2: "pl",
    code: 48,
  },
  {
    name: "Portugal",
    cca2: "pt",
    code: 351,
  },
  {
    name: "Puerto Rico",
    cca2: "pr",
    code: 1787,
  },
  {
    name: "Qatar",
    cca2: "qa",
    code: 974,
  },
  {
    name: "Reunion",
    cca2: "re",
    code: 262,
  },
  {
    name: "Romania",
    cca2: "ro",
    code: 40,
  },
  {
    name: "Russian Federation",
    cca2: "ru",
    code: 7,
  },
  {
    name: "Rwanda",
    cca2: "rw",
    code: 250,
  },
  {
    name: "Saint Kitts and Nevis",
    cca2: "kn",
    code: 1869,
  },
  {
    name: "Saint Lucia",
    cca2: "lc",
    code: 1758,
  },
  {
    name: "Saint Vincent and the Grenadines",
    cca2: "vc",
    code: 1784,
  },
  {
    name: "Samoa",
    cca2: "ws",
    code: 685,
  },
  {
    name: "San Marino",
    cca2: "sm",
    code: 378,
  },
  {
    name: "Sao Tome and Principe",
    cca2: "st",
    code: 239,
  },
  {
    name: "Saudi Arabia",
    cca2: "sa",
    code: 966,
  },
  {
    name: "Senegal",
    cca2: "sn",
    code: 221,
  },
  {
    name: "Serbia",
    cca2: "rs",
    code: 381,
  },
  {
    name: "Seychelles",
    cca2: "sc",
    code: 248,
  },
  {
    name: "Sierra Leone",
    cca2: "sl",
    code: 232,
  },
  {
    name: "Singapore",
    cca2: "sg",
    code: 65,
  },
  {
    name: "Slovakia",
    cca2: "sk",
    code: 421,
  },
  {
    name: "Slovenia",
    cca2: "si",
    code: 386,
  },
  {
    name: "Solomon Islands",
    cca2: "sb",
    code: 677,
  },
  {
    name: "Somalia",
    cca2: "so",
    code: 252,
  },
  {
    name: "South Africa",
    cca2: "za",
    code: 27,
  },
  {
    name: "South Korea",
    cca2: "kr",
    code: 82,
  },
  {
    name: "Spain",
    cca2: "es",
    code: 34,
  },
  {
    name: "Sri Lanka",
    cca2: "lk",
    code: 94,
  },
  {
    name: "Sudan",
    cca2: "sd",
    code: 249,
  },
  {
    name: "Suriname",
    cca2: "sr",
    code: 597,
  },
  {
    name: "Swaziland",
    cca2: "sz",
    code: 268,
  },
  {
    name: "Sweden",
    cca2: "se",
    code: 46,
  },
  {
    name: "Switzerland",
    cca2: "ch",
    code: 41,
  },
  {
    name: "Syrian Arab Republic",
    cca2: "sy",
    code: 963,
  },
  {
    name: "Taiwan, Province of China",
    cca2: "tw",
    code: 886,
  },
  {
    name: "Tajikistan",
    cca2: "tj",
    code: 992,
  },
  {
    name: "Tanzania",
    cca2: "tz",
    code: 255,
  },
  {
    name: "Thailand",
    cca2: "th",
    code: 66,
  },
  {
    name: "Timor-Leste",
    cca2: "tl",
    code: 670,
  },
  {
    name: "Togo",
    cca2: "tg",
    code: 228,
  },
  {
    name: "Tonga",
    cca2: "to",
    code: 676,
  },
  {
    name: "Trinidad and Tobago",
    cca2: "tt",
    code: 1868,
  },
  {
    name: "Tunisia",
    cca2: "tn",
    code: 216,
  },
  {
    name: "Turkey",
    cca2: "tr",
    code: 90,
  },
  {
    name: "Turkmenistan",
    cca2: "tm",
    code: 993,
  },
  {
    name: "Turks and Caicos Islands",
    cca2: "tc",
    code: 1649,
  },
  {
    name: "Tuvalu",
    cca2: "tv",
    code: 688,
  },
  {
    name: "Uganda",
    cca2: "ug",
    code: 256,
  },
  {
    name: "Ukraine",
    cca2: "ua",
    code: 380,
  },
  {
    name: "United Arab Emirates",
    cca2: "ae",
    code: 971,
  },
  {
    name: "United Kingdom",
    cca2: "gb",
    code: 44,
  },
  {
    name: "United States",
    cca2: "us",
    code: 1,
  },
  {
    name: "Uruguay",
    cca2: "uy",
    code: 598,
  },
  {
    name: "Uzbekistan",
    cca2: "uz",
    code: 998,
  },
  {
    name: "Vanuatu",
    cca2: "vu",
    code: 678,
  },
  {
    name: "Vatican City",
    cca2: "va",
    code: 379,
  },
  {
    name: "Venezuela",
    cca2: "ve",
    code: 58,
  },
  {
    name: "Viet Nam",
    cca2: "vn",
    code: 84,
  },
  {
    name: "Virgin Islands (British)",
    cca2: "vg",
    code: 1284,
  },
  {
    name: "Virgin Islands (U.S.)",
    cca2: "vi",
    code: 1340,
  },
  {
    name: "Western Sahara",
    cca2: "eh",
    code: 212,
  },
  {
    name: "Yemen",
    cca2: "ye",
    code: 967,
  },
  {
    name: "Zambia",
    cca2: "zm",
    code: 260,
  },
  {
    name: "Zimbabwe",
    cca2: "zw",
    code: 263,
  },
];
